export const translations: {[key:string]: LocalizableText} = {

map: {
    "en-US": "Map",
    am: "ካርታ",
    "ar-SA": "خريطة",
    "fr-FR": "Carte",
    "es-ES": "Mapa",
    "so-SO": "Khariidad",
    "ur-UR": "نقشہ",
    "ht": "Kat",
    "fr-HT": "Kat",
    "bn": " মানচিত্র",
    "my": "မြေပုံ",
    "cs": "Mapa",
    "fa-AF": "نقشه",
    "fa-FA": "نقشه",
    "de-DE": "Karte",
    "el": "Χάρτης",
    "ha-HA": "Taswir",
    "hu-HU": "Térkép",
    "it-IT": "Mappa",
    "KAU": "Taswir",
    "ki-KI": "Mepɔ",
    "ln-LN": "Karte",
    "ps-PS": "نقشه",
    "ru-RU": "Карта",
    "sw-SW": "Ramani",
    "th": "แผนที่",
    "uk-UK": "Карта",
},
loading: {
    "en-US": "Loading",
    am: "በመጫን ላይ",
    "ar-SA": "جارٍ التحميل",
    "fr-FR": "Chargement",
    "es-ES": "Cargando",
    "so-SO": "Waa la soo rarayaa",
    "ur-UR": "لوڈ ہو رہا ہے",
    "ht": "Ap chaje",
    "fr-HT": "Ap chaje",
    "bn": "লোড হচ্ছে",
    "my": "ဖွင့်နေသည်",
    "cs": "Načítání",
    "fa-AF": "در حال بارگذاری",
    "fa-FA": "در حال بارگذاری",
    "de-DE": "Wird geladen",
    "el": "Φόρτωση",
    "ha-HA": "Ana loda",
    "hu-HU": "Betöltés",
    "it-IT": "Caricamento",
    "KAU": "Ana loda",
    "ki-KI": "Irakiratirwo",
    "ln-LN": "Ezali kokota",
    "ps-PS": "بارېږي",
    "ru-RU": "Загрузка",
    "sw-SW": "Inapakia",
    "th": "กำลังโหลด",
    "uk-UK": "Завантаження",
},
newChat: {
    "en-US": "New chat",
    am: "አዲስ ውይይት",
    "ar-SA": "محادثة جديدة",
    "fr-FR": "Nouvelle discussion",
    "es-ES": "Nuevo chat",
    "so-SO": "Wada hadal cusub",
    "ur-UR": "نئی گفتگو",
    "ht": "Nouvo chat",
    "fr-HT": "Nouvo chat",
    "bn": "নতুন চ্যাট",
    "my": "စကားပြောအသစ်",
    "cs": "Nový chat",
    "fa-AF": "گفتگوی جدید",
    "fa-FA": "گفتگوی جدید",
    "de-DE": "Neuer Chat",
    "el": "Νέα συνομιλία",
    "ha-HA": "Sabuwar tattaunawa",
    "hu-HU": "Új csevegés",
    "it-IT": "Nuova chat",
    "ps-PS": "نوې خبرې اترې",
    "ru-RU": "Новый чат",
    "sw-SW": "Gumzo jipya",
    "th": "แชทใหม่",
    "uk-UK": "Новий чат",
},
previous: {
    "en-US": "Previous",
    am: "ቀዳሚ",
    "ar-SA": "السابق",
    "fr-FR": "Précédent",
    "es-ES": "Anterior",
    "so-SO": "Hore",
    "ur-UR": "پچھلا",
    "ht": "Anvan",
    "fr-HT": "Anvan",
    "bn": "পূর্ববর্তী",
    "my": "ယခင်",
    "cs": "Předchozí",
    "fa-AF": "قبلی",
    "fa-FA": "قبلی",
    "de-DE": "Zurück",
    "el": "Προηγούμενο",
    "ha-HA": "Baya",
    "hu-HU": "Előző",
    "it-IT": "Precedente",
    "KAU": "Previous",
    "ki-KI": "Previous",
    "ln-LN": "Previous",
    "ps-PS": "مخکینی",
    "ru-RU": "Предыдущая",
    "sw-SW": "Iliyotangulia",
    "th": "ก่อนหน้า",
    "uk-UK": "Попередня",
},
next: {
    "en-US": "Next",
    am: "ቀጣይ",
    "ar-SA": "التالي",
    "fr-FR": "Suivant",
    "es-ES": "Siguiente",
    "so-SO": "Xiga",
    "ur-UR": "اگلا",
    "ht": "Apre",
    "fr-HT": "Apre",
    "bn": "পরবর্তী",
    "my": "နောက်",
    "cs": "Další",
    "fa-AF": "بعدی",
    "fa-FA": "بعدی",
    "de-DE": "Weiter",
    "el": "Επόμενο",
    "ha-HA": "Na gaba",
    "hu-HU": "Következő",
    "it-IT": "Successivo",
    "KAU": "Next",
    "ki-KI": "Next",
    "ln-LN": "Next",
    "ps-PS": "راتلونکی",
    "ru-RU": "Следующая",
    "sw-SW": "Ifuatayo",
    "th": "ถัดไป",
    "uk-UK": "Наступна",
},
pagination: {
    "en-US": "Pagination",
    am: "ገጽ ቁጥር",
    "ar-SA": "ترقيم الصفحات",
    "fr-FR": "Pagination",
    "es-ES": "Paginación",
    "so-SO": "Bogagga",
    "ur-UR": "صفحہ بندی",
    "ht": "Paginasyon",
    "fr-HT": "Paginasyon",
    "bn": "পৃষ্ঠা বিন্যাস",
    "my": "စာမျက်နှာ ခွဲခြင်း",
    "cs": "Stránkování",
    "fa-AF": "صفحه‌بندی",
    "fa-FA": "صفحه‌بندی",
    "de-DE": "Seitennummerierung",
    "el": "Σελιδοποίηση",
    "ha-HA": "Lissafin shafuka",
    "hu-HU": "Lapozás",
    "it-IT": "Impaginazione",
    "KAU": "Pagination",
    "ki-KI": "Pagination",
    "ln-LN": "Pagination",
    "ps-PS": "پاڼې شمېرل",
    "ru-RU": "Пагинация",
    "sw-SW": "Ukurasa",
    "th": "การแบ่งหน้า",
    "uk-UK": "Нумерація сторінок",
},
close: {
    "en-US": "Close",
    am: "ዝጋ",
    "ar-SA": "إغلاق",
    "fr-FR": "Fermer",
    "es-ES": "Cerrar",
    "so-SO": "Xir",
    "ur-UR": "بند کریں",
    "ht": "Fèmen",
    "fr-HT": "Fèmen",
    "bn": "বন্ধ করুন",
    "my": "ပိတ်ရန်",
    "cs": "Zavřít",
    "fa-AF": "بستن",
    "fa-FA": "بستن",
    "de-DE": "Schließen",
    "el": "Κλείσιμο",
    "ha-HA": "Rufe",
    "hu-HU": "Bezárás",
    "it-IT": "Chiudi",
    "KAU": "Close",
    "ki-KI": "Close",
    "ln-LN": "Close",
    "ps-PS": "بندول",
    "ru-RU": "Закрыть",
    "sw-SW": "Funga",
    "th": "ปิด",
    "uk-UK": "Закрити",
},
navigationMenu: {
    "en-US": "Navigation menu",
    am: "የአሰሳ ምናሌ",
    "ar-SA": "قائمة التنقل",
    "fr-FR": "Menu de navigation",
    "es-ES": "Menú de navegación",
    "so-SO": "Menu-ga hagida",
    "ur-UR": "نیویگیشن مینو",
    "ht": "Meni navigasyon",
    "fr-HT": "Meni navigasyon",
    "bn": "নেভিগেশন মেনু",
    "my": "လမ်းညွှန် မီနူး",
    "cs": "Navigační nabídka",
    "fa-AF": "منوی ناوبری",
    "fa-FA": "منوی ناوبری",
    "de-DE": "Navigationsmenü",
    "el": "Μενού πλοήγησης",
    "ha-HA": "Menu na kewayawa",
    "hu-HU": "Navigációs menü",
    "it-IT": "Menu di navigazione",
    "KAU": "Navigation menu",
    "ki-KI": "Navigation menu",
    "ln-LN": "Navigation menu",
    "ps-PS": "د نیویګیشن مینو",
    "ru-RU": "Меню навигации",
    "sw-SW": "Menyu ya urambazaji",
    "th": "เมนูนำทาง",
    "uk-UK": "Меню навігації",
},
breadcrumb: {
    "en-US": "Breadcrumb",
    am: "የአሰሳ መንገድ",
    "ar-SA": "مسار التنقل",
    "fr-FR": "Fil d'Ariane",
    "es-ES": "Ruta de navegación",
    "so-SO": "Jidka",
    "ur-UR": "بریڈ کرمب",
    "ht": "Chemen navigasyon",
    "fr-HT": "Chemen navigasyon",
    "bn": "ব্রেডক্রাম্ব",
    "my": "လမ်းကြောင်း",
    "cs": "Drobečková navigace",
    "fa-AF": "مسیر راهنما",
    "fa-FA": "مسیر راهنما",
    "de-DE": "Brotkrümelnavigation",
    "el": "Διαδρομή πλοήγησης",
    "ha-HA": "Hanyar kewayawa",
    "hu-HU": "Morzsamenü",
    "it-IT": "Percorso di navigazione",
    "KAU": "Breadcrumb",
    "ki-KI": "Breadcrumb",
    "ln-LN": "Breadcrumb",
    "ps-PS": "د لارې نښه",
    "ru-RU": "Хлебные крошки",
    "sw-SW": "Njia ya urambazaji",
    "th": "เส้นทางนำทาง",
    "uk-UK": "Хлібні крихти",
},
copied: {
    "en-US": "Copied!",
    am: "ተቀድቷል!",
    "ar-SA": "تم النسخ!",
    "fr-FR": "Copié!",
    "es-ES": "Copiado!",
    "so-SO": "Laabtay!",
    "ur-UR": "نقل کر دیا!",
    "ht": "Kopie!",
    "fr-HT": "Kopie!",
    "bn": "কপি করা হয়েছে!",
    "my": "ကူးယူထားသည်!",
    "cs": "Zkopírováno!",
    "fa-AF": "کپی شد!",
    "fa-FA": "کپی شد!",
    "de-DE": "Kopiert!",
    "el": "Αντιγράφηκε!",
    "ha-HA": "An kopi!",
    "hu-HU": "Másolva!",
    "it-IT": "Copiato!",
    "KAU": "An kopi!",
    "ki-KI": "Kopie!",
    "ln-LN": "Kopie!",
    "ps-PS": "نقل شوی!",
    "ru-RU": "Скопировано!",
    "sw-SW": "Imenakiliwa!",
    "th": "คัดลอกแล้ว!",
    "uk-UK": "Скопійовано!"
},
home: {
    "en-US": "Home",
    am: "መነሻ",
    "ar-SA": "الرئيسية",
    "fr-FR": "Accueil",
    "es-ES": "Inicio",
    "so-SO": "Bogga Hore",
    "ur-UR": "گھر",
    "ht": "Lakay",
    "fr-HT": "Lakay",
    "bn": "মূল পাতা",
    "my": "ပင်မစာမျက်နှာ",
    "cs": "Domov",
    "fa-AF": "صفحهٔ اصلی",
    "fa-FA": "صفحهٔ اصلی",
    "de-DE": "Startseite",
    "el": "Αρχική",
    "ha-HA": "Gida",
    "hu-HU": "Otthon",
    "it-IT": "Home",
    "KAU": "Gida",
    "ki-KI": "Ihoya",
    "ln-LN": "Nyumba",
    "ps-PS": "کور",
    "ru-RU": "Главная",
    "sw-SW": "Nyumbani",
    "th": "หน้าหลัก",
    "uk-UK": "Головна"
},
list: {
   "en-US": "List",
   am: "ዝርዝር",
    "ar-SA": "قائمة",
    "fr-FR": "Liste",
    "es-ES": "Lista",
    "so-SO": "Liis",
    "ur-UR": "فہرست",
    "ht": "Lis",
    "fr-HT": "Lis",
    "bn": "তালিকা",
    "my": "စာရင်း",
    "cs": "Seznam",
    "fa-AF": "فهرست",
    "fa-FA": "لیست",
    "de-DE": "Liste",
    "el": "Λίστα",
    "ha-HA": "Jerin",
    "hu-HU": "Lista",
    "it-IT": "Elenco",
    "KAU": "Jerin",
    "ki-KI": "Rangorua",
    "ln-LN": "Liste",
    "ps-PS": "لیست",
    "ru-RU": "Список",
    "sw-SW": "Orodha",
    "th": "รายการ",
    "uk-UK": "Список"
},
topics: {
    "en-US": "Topic",
    am: "ርዕስ",
    "ar-SA": "عنوان",
    "fr-FR": "Sujet",
    "es-ES": "Tema",
    "so-SO": "mawduuca",
    "ur-UR": "موضوع",
    "ht": "Sijè",
    "fr-HT": "Sijè",
    "bn": "বিষয়",
    "my": "အကြောင်းအရာ",
    "cs": "Téma",
    "fa-AF": "موضوع",
    "fa-FA": "موضوع",
    "de-DE": "Thema",
    "el": "Θέμα",
    "ha-HA": "Jigon",
    "hu-HU": "Téma",
    "it-IT": "Argomento",
    "KAU": "Jigon",
    "ki-KI": "Kihio",
    "ln-LN": "Moto ya likambo",
    "ps-PS": "موضوع",
    "ru-RU": "Тема",
    "sw-SW": "Mada",
    "th": "หัวข้อ",
    "uk-UK": "Тема"
},
accesibility: {
    "en-US": "Accessibility",
    am: "ተደራሽነት",
    "ar-SA": "إمكانية الوصول",
    "fr-FR": "Accessibilité",
    "es-ES": "Accesibilidad",
    "so-SO": "Qalabka",
    "ur-UR": "رسائی",
    "ht": "Aksè",
    "fr-HT": "Aksè",
    "bn": "প্রবেশযোগ্যতা",
    "my": "ရှေ့နယ်မှု",
    "cs": "Přístupnost",
    "fa-AF": "دسترسی",
    "fa-FA": "دسترس‌پذیری",
    "de-DE": "Barrierefreiheit",
    "el": "Προσβασιμότητα",
    "ha-HA": "Yiwa",
    "hu-HU": "Hozzáférhetőség",
    "it-IT": "Accessibilità",
    "KAU": "Yiwa",
    "ki-KI": "Kuragwo",
    "ln-LN": "Bokoki ya kozwa yango",
    "ps-PS": "لاسرسۍ",
    "ru-RU": "Доступность",
    "sw-SW": "Ufikiaji",
    "th": "การเข้าถึง",
    "uk-UK": "Доступність"
},
latestArticle: {
  "en-US": "Latest Article",
  am: "የቅርብ ጊዜ ጽሑፍ",
  "ar-SA": "أحدث مقال",
  "fr-FR": "Dernier article",
  "es-ES": "Último artículo",
  "so-SO": "Maqaalka ugu dambeeyay",
  "ur-UR": "تازہ ترین مضمون",
  "ht": "Dènye Atik",
  "fr-HT": "Dènye Atik",
  "bn": "সর্বশেষ প্রবন্ধ",
  "my": "နောက်ဆုံးဆောင်းပါး",
  "cs": "Nejnovější článek",
  "fa-AF": "آخرین مقاله",
  "fa-FA": "جدیدترین مقاله",
  "de-DE": "Neuester Artikel",
  "el": "Τελευταίο άρθρο",
  "ha-HA": "Sabon Labari",
  "hu-HU": "Legújabb cikk",
  "it-IT": "Ultimo articolo",
  "KAU": "Sabon Labari",
  "ki-KI": "Nĩrũ ya ũthoni",
  "ln-LN": "Lisolo ya sika",
  "ps-PS": "نوې مقاله",
  "ru-RU": "Последняя статья",
  "sw-SW": "Makala ya mwisho",
  "th": "บทความล่าสุด",
  "uk-UK": "Остання стаття"
},
category: {
   "en-US": "Category",
   am: "ምድብ",
    "ar-SA": "فئة",
    "fr-FR": "Catégorie",
    "es-ES": "Categoría",
    "so-SO": "Qaybta",
    "ur-UR": "زمرہ",
    "ht": "Kategori",
    "fr-HT": "Kategori",
    "bn": "শ্রেণি বা বিভাগ",
    "my": "အမျိုးအစား",
    "cs": "Kategorie",
    "fa-AF": "دسته",
    "fa-FA": "دسته‌بندی",
    "de-DE": "Kategorie",
    "el": "Κατηγορία",
    "ha-HA": "Rukuni",
    "hu-HU": "Kategória",
    "it-IT": "Categoria",
    "KAU": "Rukuni",
    "ki-KI": "Kikundi",
    "ln-LN": "Lolenge",
    "ps-PS": "کتګورۍ",
    "ru-RU": "Категория",
    "sw-SW": "Kategoria",
    "th": "หมวดหมู่",
    "uk-UK": "Категорія"
},
filterByNewOrOld: {
    "en-US": "Filter by new or old",
    am: "በአዲስ ወይም በአሮጌ አጣራ",
    "ar-SA": "تصفية حسب الأحدث أو الأقدم",
    "fr-FR": "Filtrer par récent ou ancien",
    "es-ES": "Filtrar por nuevo o antiguo",
    "so-SO": "Kala sooc cusub ama duug",
    "ur-UR": "نئے یا پرانے کے لحاظ سے فلٹر کریں",
    "ht": "Filtre selon nouvo oswa ansyen",
    "fr-HT": "Filtre selon nouvo oswa ansyen",
    "bn": "নতুন বা পুরোনো অনুসারে ফিল্টার করুন",
    "my": "အသစ် သို့မဟုတ် အဟောင်းဖြင့် စစ်ထုတ်ပါ",
    "cs": "Filtrovat podle nového nebo starého",
    "fa-AF": "فیلتر بر اساس جدید یا قدیمی",
    "fa-FA": "فیلتر بر اساس جدید یا قدیمی",
    "de-DE": "Nach neu oder alt filtern",
    "el": "Φιλτράρισμα κατά νέο ή παλιό",
    "ha-HA": "Tace ta sabo ko tsoho",
    "hu-HU": "Szűrés új vagy régi szerint",
    "it-IT": "Filtra per nuovo o vecchio",
    "KAU": "Tace ta sabo ko tsoho",
    "ki-KI": "Shungura ku bishasha canke ku bishaje",
    "ln-LN": "Bongisa na ya sika to ya kala",
    "ps-PS": "د نوي یا زوړ له مخې فلټر کړئ",
    "ru-RU": "Фильтровать по новым или старым",
    "sw-SW": "Chuja kwa mpya au zamani",
    "th": "กรองตามใหม่หรือเก่า",
    "uk-UK": "Фільтрувати за новими або старими",
},
readMore: {
    "en-US": "Read more",
    am: "ተጨማሪ ያንብቡ",
    "ar-SA": "اقرأ أكثر",
    "fr-FR": "Lire la suite",
    "es-ES": "Leer más",
    "so-SO": "Akhri wax dheeraad ah",
    "ur-UR": "مزید پڑھیں",
    "ht": "Li plis",
    "fr-HT": "Li plis",
    "bn": "আরও পড়ুন",
    "my": "ပို၍ ဖတ်ပါ",
    "cs": "Přečtěte si více",
    "fa-AF": "بیشتر بخوانید",
    "fa-FA": "بیش‌تر بخوانید",
    "de-DE": "Mehr lesen",
    "el": "Διαβάστε περισσότερα",
    "ha-HA": "Karanta ƙarin",
    "hu-HU": "Tovább olvasom",
    "it-IT": "Leggi di più",
    "KAU": "Karanta ƙarin",
    "ki-KI": "Soma kiria",
    "ln-LN": "Tanga makambo mosusu",
    "ps-PS": "نور ولولئ",
    "ru-RU": "Читать далее",
    "sw-SW": "Soma zaidi",
    "th": "อ่านเพิ่มเติม",
    "uk-UK": "Читати далі"
},
lastUpdated: {
    "en-US": "Last Updated",
    am: "መጨረሻ የተዘመነ",
    "ar-SA": "آخر تحديث",
    "fr-FR": "Dernière mise à jour",
    "es-ES": "Última actualización",
    "so-SO": "Update ugu dambeeyay",
    "ur-UR": "آخری تازہ کاری",
    "ht": "Dènye Mizajou",
    "fr-HT": "Dènye Mizajou",
    "bn": "সর্বশেষ হালনাগাদ",
    "my": "နောက်ဆုံး အပ်ဒိတ်",
    "cs": "Naposledy aktualizováno",
    "fa-AF": "آخرین به روزرسانی",
    "fa-FA": "آخرین به‌روزرسانی",
    "de-DE": "Letzte Aktualisierung",
    "el": "Τελευταία ενημέρωση",
    "ha-HA": "Sabon sabuntawa",
    "hu-HU": "Utolsó frissítés",
    "it-IT": "Ultimo aggiornamento",
    "KAU": "Sabon sabuntawa",
    "ki-KI": "Kugika",
    "ln-LN": "Mikolo ya suka",
    "ps-PS": "وروستي تازه معلومات",
    "ru-RU": "Последнее обновление",
    "sw-SW": "Sahihisho la mwisho",
    "th": "อัปเดตล่าสุด",
    "uk-UK": "Останнє оновлення"
},
filters: {
    "en-US": "Filters",
    am: "ማጣሪያዎች",
    "ar-SA": "التصنيفات ",
    "fr-FR": "Filtres",
    "es-ES": "Filtros",
    "so-SO": "Shaandhayaal",
    "ur-UR": "فلٹرز",
    "ht": "Filtè",
    "fr-HT": "Filtre",
    "bn": "ফিল্টার বা ছাঁকনি",
    "my": "ဖီလတာ",
    "cs": "Filtry",
    "fa-AF": "فیلترها",
    "fa-FA": "فیلترها",
    "de-DE": "Filter",
    "el": "Φίλτρα",
    "ha-HA": "Fitar",
    "hu-HU": "Szűrők",
    "it-IT": "Filtri",
    "KAU": "Fitar",
    "ki-KI": "Filita",
    "ln-LN": "Filtre",
    "ps-PS": "فلټرونه",
    "ru-RU": "Фильтры",
    "sw-SW": "Vichujio",
    "th": "ตัวกรอง",
    "uk-UK": "Фільтри"
},
serviceTypes: {
    "en-US": "Service Category",
    am: "የአገልግሎት ምድብ",
    "ar-SA": "أنواع الخدمة",
    "fr-FR": "Types de service",
    "es-ES": "Tipos de servicio",
    "so-SO": "Noocyada Adeegyada",
    "ur-UR": "سروس کی اقسام",
    "ht": "Kalite Sèvis",
    "fr-HT": "Kalite Sèvis",
    "bn": "সেবার ধরণ",
    "my": "ဝန်ဆောင်မှုအမျိုးအစား",
    "cs": "Typy služeb",
    "fa-AF": "انواع خدمات",
    "fa-FA": "انواع خدمات",
    "de-DE": "Diensttypen",
    "el": "Τύποι υπηρεσιών",
    "ha-HA": "Nau'o'in Ayyuka",
    "hu-HU": "Szolgáltatástípusok",
    "it-IT": "Tipi di servizio",
    "KAU": "Nau'o'in Ayyuka",
    "ki-KI": "Ndhuma cia",
    "ln-LN": "Mitindo ya Misala",
    "ps-PS": "د خدمت ډولونه",
    "ru-RU": "Типы услуг",
    "sw-SW": "Aina za Huduma",
    "th": "ประเภทบริการ",
    "uk-UK": "Типи послуг"
},
resourceCenter: {
    "en-US": "Resource Center",
    am: "የመረጃ ማዕከል",
    "ar-SA": "مركز الموارد",
    "fr-FR": "Centre de ressources",
    "es-ES": "Centro de recursos",
    "so-SO": "Xarunta kheyraadka",
    "ur-UR": "وسائل کا مرکز",
    "ht": "Sant Resous",
    "fr-HT": "Sant Resous",
    "bn": "সম্পদ কেন্দ্র",
    "my": "အရင်းအမြစ်ကော်စီ",
    "cs": "Centrum zdrojů",
    "fa-AF": "مرکز منابع",
    "fa-FA": "مرکز منابع",
    "de-DE": "Ressourcenzentrum",
    "el": "Κέντρο πόρων",
    "ha-HA": "Cibiyar Albarkatun",
    "hu-HU": "Erőforrás központ",
    "it-IT": "Centro risorse",
    "KAU": "Cibiyar Albarkatun",
    "ki-KI": "Ndurumo ya wendo",
    "ln-LN": "Centre ya lisunngi ya mosolo",
    "ps-PS": "د سرچینو مرکز",
    "ru-RU": "Центр ресурсов",
    "sw-SW": "Kituo cha Rasilimali",
    "th": "ศูนย์ข้อมูล",
    "uk-UK": "Центр ресурсів"
},
provider: {
    "en-US": "Provider",
    am: "አቅራቢ",
    "ar-SA": "مزود",
    "fr-FR": "Fournisseur",
    "es-ES": "Proveedor",
    "so-SO": "Bixiye",
    "ur-UR": "فراہمی کرنے والا",
    "ht": "Founisè",
    "fr-HT": "Founisè",
    "bn": "প্রদানকারী",
    "my": "ပေးသွင်းသူ",
    "cs": "Poskytovatel",
    "fa-AF": "عرضه کننده",
    "fa-FA": "ارایه‌دهنده",
    "de-DE": "Anbieter",
    "el": "Προμηθευτής",
    "ha-HA": "Mai bayar",
    "hu-HU": "Szolgáltató",
    "it-IT": "Fornitore",
    "KAU": "Mai bayar",
    "ki-KI": "Mũgũndũ",
    "ln-LN": "Mopesi ya biloko",
    "ps-PS": "وړاندې کوونکی",
    "ru-RU": "Поставщик",
    "sw-SW": "Mtoa huduma",
    "th": "ผู้ให้บริการ",
    "uk-UK": "Постачальник"
},
showing: {
    "en-US": "Showing",
    am: "እያሳየ",
    "ar-SA": "عرض",
    "fr-FR": "Affichage",
    "es-ES": "Mostrando",
    "so-SO": "Muujinaya",
    "ur-UR": "دکھا رہا ہے",
    "ht": "Ap Montre",
    "fr-HT": "Ap Montre",
    "bn": "দেখানো হচ্ছে",
    "my": "ပြသနေသည်",
    "cs": "Zobrazení",
    "fa-AF": "در حال نمایش",
    "fa-FA": "نمایش",
    "de-DE": "Anzeigen",
    "el": "Εμφάνιση",
    "ha-HA": "Nuna",
    "hu-HU": "Kijelző",
    "it-IT": "Visualizzazione",
    "KAU": "Nuna",
    "ki-KI": "Nĩrũ",
    "ln-LN": "Kolakisa",
    "ps-PS": "ښودل",
    "ru-RU": "Показ",
    "sw-SW": "Inaonyesha",
    "th": "กำลังแสดง",
    "uk-UK": "Показуємо"
},
allServiceTypes: {
    "en-US": "All Service Categories",
    am: "ሁሉም የአገልግሎት ምድቦች",
    "ar-SA": "جميع أنواع الخدمات",
    "fr-FR": "Tous les types de services",
    "es-ES": "Todos los tipos de servicios",
    "so-SO": "Dhammaan noocyada adeegyada",
    "ur-UR": "تمام سروس کی اقسام",
    "ht": "Tout Tip Sèvis",
    "fr-HT": "Tout Tip Sèvis",
    "bn": "সমস্ত পরিষেবার ধরন",
    "my": "အားလုံး ဝန်ဆောင်မှု အမျိုးအစား",
    "cs": "Všechny typy služeb",
    "fa-AF": "همه انواع خدمات",
    "fa-FA": "همه انواع خدمات",
    "de-DE": "Alle Diensttypen",
    "el": "Όλοι οι τύποι υπηρεσιών",
    "ha-HA": "Dukkan Nau'o'in Ayyuka",
    "hu-HU": "Minden szolgáltatástípus",
    "it-IT": "Tutti i tipi di servizio",
    "KAU": "Dukkan Nau'o'in Ayyuka",
    "ki-KI": "Ndhuma cia zose",
    "ln-LN": "Mitindo nyonso ya Misala",
    "ps-PS": "د خدمتونو ټول ډولونه",
    "ru-RU": "Все типы услуг",
    "sw-SW": "Aina Zote za Huduma",
    "th": "ประเภทบริการทั้งหมด",
    "uk-UK": "Усі типи послуг"
},
allProviders: {
    "en-US": "All Providers",
    am: "ሁሉም አቅራቢዎች",
    "ar-SA": "جميع مقدمي الخدمة",
    "fr-FR": "Tous les fournisseurs",
    "es-ES": "Todos los proveedores",
    "so-SO": "Dhammaan bixiyeyaasha",
    "ur-UR": "تمام فراہم کنندگان",
    "ht": "Tout Founisè yo",
    "fr-HT": "Tout Founisè yo",
    "bn": "সমস্ত প্রদানকার",
    "my": "အားလုံး ပေးသွင်းသူများ",
    "cs": "Všichni poskytovatelé",
    "fa-AF": "تمام ارائه کنندگان",
    "fa-FA": "همه ارایه‌دهندگان",
    "de-DE": "Alle Anbieter",
    "el": "Όλοι οι προμηθευτές",
    "ha-HA": "Dukkan Masu bayar",
    "hu-HU": "Minden szolgáltató",
    "it-IT": "Tutti i fornitori",
    "KAU": "Dukkan Masu bayar",
    "ki-KI": "Witũ wĩrĩ",
    "ln-LN": "Ba Fournisseurs nionso",
    "ps-PS": "ټول وړاندې کوونکي",
    "ru-RU": "Все поставщики",
    "sw-SW": "Watoa Huduma",
    "th": "ผู้ให้บริการทั้งหมด",
    "uk-UK": "Усі постачальники"
},
accessibilities: {
    "en-US": "Accessibilities",
    am: "ተደራሽነቶች",
    "ar-SA": "إمكانية الوصول",
    "fr-FR": "Accessibilités",
    "es-ES": "Accesibilidades",
    "so-SO": "Helidda",
    "ur-UR": "قابل رسائی",
    "ht": "Aksè",
    "fr-HT": "Aksè",
    "bn": "প্রবেশযোগ্যতা",
    "my": "လက်လှမ်းမှီနိုင်စွမ်းများ",
    "cs": "Přístupnost",
    "fa-AF": "دسترسی‌ها",
    "fa-FA": "دسترس‌پذیری‌ها",
    "de-DE": "Barrierefreiheit",
    "el": "Προσβασιμότητες",
    "ha-HA": "Dama na shiga",
    "hu-HU": "Hozzáférhetőségek",
    "it-IT": "Accessibilità",
    "KAU": "Dama na shiga",
    "ki-KI": "Iguamũranĩro",
    "ln-LN": "Bokoki ya kozwa yango",
    "ps-PS": "لاسرسیانې",
    "ru-RU": "Доступности",
    "sw-SW": "Jinsi ya kufika",
    "th": "การเข้าถึง",
    "uk-UK": "Доступність"
},
allAccessibilities: {
    "en-US": "All Accessibilities",
    am: "ሁሉም ተደራሽነቶች",
    "ar-SA": "جميع إمكانيات الوصول",
    "fr-FR": "Toutes les accessibilités",
    "es-ES": "Todas las accesibilidades",
    "so-SO": "Dhammaan Helidda",
    "ur-UR": "تمام قابل رسائیاں",
    "ht": "Tout aksè yo",
    "fr-HT": "Tout aksè yo",
    "bn": "সকল প্রবেশযোগ্যতা",
    "my": "လက်လှမ်းမှီနိုင်စွမ်း အားလုံး",
    "cs": "Všechny přístupnosti",
    "fa-AF": "همه دسترسی‌ها",
    "fa-FA": "همه دسترس‌پذیری‌ها",
    "de-DE": "Alle Barrierefreiheiten",
    "el": "Όλες οι προσβασιμότητες",
    "ha-HA": "Dukkan dama na shiga",
    "hu-HU": "Minden hozzáférhetőség",
    "it-IT": "Tutte le accessibilità",
    "KAU": "Dukkan dama na shiga",
    "ki-KI": "Iguamũranĩro ciothe",
    "ln-LN": "Bokoki ya kozwa yango nyoso",
    "ps-PS": "ټولې لاسرسیانې",
    "ru-RU": "Все доступности",
    "sw-SW": "Ufikiaji wote",
    "th": "การเข้าถึงทั้งหมด",
    "uk-UK": "Всі доступності"
},
populations: {
    "en-US": "Populations Served",
    am: "የሚያገለግሉ ህዝቦች",
    "ar-SA": "الفئات المستهدفة",
    "fr-FR": "Populations desservies",
    "es-ES": "Poblaciones atendidas",
    "so-SO": "Bulshooyinka La Adeegayo",
    "ur-UR": "خدمت کی جانے والی آبادی",
    "ht": "Popilasyon yo sèvi",
    "fr-HT": "Popilasyon yo sèvi",
    "bn": "সেবা-প্রাপ্ত জনগোষ্ঠী",
    "my": "ဆောင်ရွက်သည့် လူဦးရေ",
    "cs": "Obsluhované populace",
    "fa-AF": "جمعیت‌های خدمت‌رسانی شده",
    "fa-FA": "گروه‌های هدف",
    "de-DE": "Zielgruppen",
    "el": "Εξυπηρετούμενοι πληθυσμοί",
    "ha-HA": "Mutane da ake yi wa hidima",
    "hu-HU": "Kiszolgált csoportok",
    "it-IT": "Popolazioni servite",
    "KAU": "Mutane da ake yi wa hidima",
    "ki-KI": "Andũ matwarĩrwo",
    "ln-LN": "Bato oyo basalelaki",
    "ps-PS": "هدف ګروپونه",
    "ru-RU": "Обслуживаемое население",
    "sw-SW": "Watu Wanaohudumiwa",
    "th": "ประชากรที่ให้บริการ",
    "uk-UK": "Населення, яке обслуговується"
},
allPopulations: {
    "en-US": "All Populations Served",
    am: "ሁሉም የሚያገለግሉ ህዝቦች",
    "ar-SA": "جميع الفئات المستهدفة",
    "fr-FR": "Toutes les populations desservies",
    "es-ES": "Todas las poblaciones atendidas",
    "so-SO": "Dhammaan Bulshooyinka La Adeegayo",
    "ur-UR": "تمام خدمت کی جانے والی آبادی",
    "ht": "Tout popilasyon yo sèvi",
    "fr-HT": "Tout popilasyon yo sèvi",
    "bn": "সমস্ত সেবা-প্রাপ্ত জনগোষ্ঠী",
    "my": "ဆောင်ရွက်သည့် လူဦးရေ အားလုံး",
    "cs": "Všechny obsluhované populace",
    "fa-AF": "همه جمعیت‌های خدمت‌رسانی شده",
    "fa-FA": "همه گروه‌های هدف",
    "de-DE": "Alle Zielgruppen",
    "el": "Όλοι οι εξυπηρετούμενοι πληθυσμοί",
    "ha-HA": "Dukkan mutane da ake yi wa hidima",
    "hu-HU": "Minden kiszolgált csoport",
    "it-IT": "Tutte le popolazioni servite",
    "KAU": "Dukkan mutane da ake yi wa hidima",
    "ki-KI": "Andũ mothe matwarĩrwo",
    "ln-LN": "Bato oyo basalelaki nyoso",
    "ps-PS": "ټول هدف ګروپونه",
    "ru-RU": "Все обслуживаемое население",
    "sw-SW": "Idadi Yote ya Watu Waliohudumiwa",
    "th": "ประชากรที่ให้บริการทั้งหมด",
    "uk-UK": "Все населення, яке обслуговується"
},
searchForInformation: {
    "en-US": "Search for Information",
    am: "መረጃ ፈልግ",
    "ar-SA": "ابحث عن معلومات",
    "fr-FR": "Recherche d'informations",
    "es-ES": "Buscar información",
    "so-SO": "Raadi macluumaad",
    "ur-UR": "معلومات تلاش کریں",
    "ht": "Chèche enfòmasyon",
    "fr-HT": "Chèche enfòmasyon",
    "bn": "তথ্য অনুসন্ধান করুন",
    "my": "သတင်းအချက်အလက် ရှာပါ",
    "cs": "Hledejte informace",
    "fa-AF": "برای اطلاعات جستجو کنید",
    "fa-FA": "جست‌وجوی اطلاعات",
    "de-DE": "Nach Informationen suchen",
    "el": "Αναζητήστε πληροφορίες",
    "ha-HA": "Nemo bayani",
    "hu-HU": "Információ keresése",
    "it-IT": "Cerca informazioni",
    "KAU": "Nemo bayani",
    "ki-KI": "Wona wendo",
    "ln-LN": "Luká Basango",
    "ps-PS": "د معلوماتو لټون",
    "ru-RU": "Поиск информации",
    "sw-SW": "Tafuta Taarifa",
    "th": "ค้นหาข้อมูล",
    "uk-UK": "Пошук інформації"
},
search: {
    "en-US": "Search",
    am: "ፈልግ",
    "ar-SA": "بحث",
    "fr-FR": "Recherche",
    "es-ES": "Buscar",
    "so-SO": "Raadi",
    "ur-UR": "تلاش",
    "ht": "Chèche",
    "fr-HT": "Chèche",
    "bn": "অনুসন্ধান বা খোঁজা",
    "my": "ရှာဖွေပါ",
    "cs": "Hledat",
    "fa-AF": "جستجو کنید",
    "fa-FA": "بحث",
    "de-DE": "Suchen",
    "el": "Αναζήτηση",
    "ha-HA": "Nemo",
    "hu-HU": "Keresés",
    "it-IT": "Cerca",
    "KAU": "Nemo",
    "ki-KI": "Wona",
    "ln-LN": "Koluka",
    "ps-PS": "لټون",
    "ru-RU": "Поиск",
    "sw-SW": "Tafuta",
    "th": "ค้นหา",
    "uk-UK": "Пошук"
},
seeMoreDetails: {
    "en-US": "See More Details",
    am: "ተጨማሪ ዝርዝሮችን ይመልከቱ",
    "ar-SA": "انظر المزيد من التفاصيل",
    "fr-FR": "Voir plus de détails",
    "es-ES": "Ver más detalles",
    "so-SO": "Arag faahfaahin dheeraad ah",
    "ur-UR": "مزید تفصیلات دیکھیں",
    "ht": "Gade plis detay",
    "fr-HT": "Gade plis detay",
    "bn": "আরও বিস্তারিত দেখুন",
    "my": "အသေးစိတ်ထပ်မြင်ပါ",
    "cs": "Zobrazit více podrobností",
    "fa-AF": "جزئیات بیشتر را ببینید",
    "fa-FA": "مشاهده جزییات بیش‌تر",
    "de-DE": "Weitere Details anzeigen",
    "el": "Δείτε περισσότερες λεπτομέρειες",
    "ha-HA": "Duba ƙarin bayani",
    "hu-HU": "További részletek megtekintése",
    "it-IT": "Vedi ulteriori dettagli",
    "KAU": "Kalli karin bayani",
    "ki-KI": "Wana kĩũkĩũ ũthoni",
    "ln-LN": "Tala Makambo mosusu",
    "ps-PS": "د نورو جزییات لیدل",
    "ru-RU": "Смотрите больше деталей",
    "sw-SW": "Tazama Maelezo Zaidi",
    "th": "ดูรายละเอียดเพิ่มเติม",
    "uk-UK": "Дивіться більше деталей"
},
allSearchResults: {
    "en-US": "All Search Results",
    am: "ሁሉም የፍለጋ ውጤቶች",
    "ar-SA": "جميع نتائج البحث",
    "fr-FR": "Tous les résultats de recherche",
    "es-ES": "Todos los resultados de búsqueda",
    "so-SO": "Dhammaan natiijooyinka raadinta",
    "ur-UR": "تمام تلاش کے نتائج",
    "ht": "Tout Rezilta Rechèch yo",
    "fr-HT": "Tout Rezilta Rechèch yo",
    "bn": "অনুসন্ধানের সকল ফলাফল",
    "my": "အကုန်ရှာဖွေမှုရလဒ်များ",
    "cs": "Všechny výsledky hledání",
    "fa-AF": "تمام نتایج جستجو",
    "fa-FA": "همه نتایج جست‌وجو",
    "de-DE": "Alle Suchergebnisse",
    "el": "Όλα τα αποτελέσματα αναζήτησης",
    "ha-HA": "Dukkan sakamakon bincike",
    "hu-HU": "Összes keresési eredmény",
    "it-IT": "Tutti i risultati di ricerca",
    "KAU": "Dukkan sakamakon bincike",
    "ki-KI": "Maki mĩhĩrĩa ya kwĩkĩra",
    "ln-LN": "Ba mbano Nionso ya Boluki",
    "ps-PS": "د لټون ټولې پایلې",
    "ru-RU": "Все результаты поиска",
    "sw-SW": "Matokeo Yote",
    "th": "ผลการค้นหาทั้งหมด",
    "uk-UK": "Усі результати пошуку"
},
informationResults: {
    "en-US": "Information Results",
    am: "የመረጃ ውጤቶች",
    "ar-SA": "نتائج المعلومات",
    "fr-FR": "Résultats d'information",
    "es-ES": "Resultados de información",
    "so-SO": "Natiijooyinka macluumaadka",
    "ur-UR": "معلومات کے نتائج",
    "ht": "Rezilta Enfòmasyon",
    "fr-HT": "Rezilta Enfòmasyon",
    "bn": "তথ্য ফলাফল",
    "my": "သတင်းအချက်အလက်ရလဒ်များ",
    "cs": "Výsledky informací",
    "fa-AF": "نتایج اطلاعات",
    "fa-FA": "نتایج اطلاعات",
    "de-DE": "Informations Ergebnisse",
    "el": "Αποτελέσματα πληροφοριών",
    "ha-HA": "Sakamakon bayani",
    "hu-HU": "Információs eredmények",
    "it-IT": "Risultati informativi",
    "KAU": "Sakamakon bayani",
    "ki-KI": "Maki maũkĩtĩ ya ũhoro",
    "ln-LN": "Mbano ya basongo",
    "ps-PS": "د معلوماتو پایلې",
    "ru-RU": "Результаты информации",
    "sw-SW": "Matokeo ya Taarifa",
    "th": "ผลลัพธ์ข้อมูล",
    "uk-UK": "Результати інформації"
},
serviceResults: {
    "en-US": "Service Results",
    am: "የአገልግሎት ውጤቶች",
    "ar-SA": "نتائج الخدمة",
    "fr-FR": "Résultats de service",
    "es-ES": "Resultados del servicio",
    "so-SO": "Natiijooyinka adeegga",
    "ur-UR": "سروس کے نتائج",
    "ht": "Rezilta Sèvis",
    "fr-HT": "Rezilta Sèvis",
    "bn": "সেবার ফলাফল",
    "my": "ဝန်ဆောင်မှုရလဒ်များ",
    "cs": "Výsledky služby",
    "fa-AF": "نتایج خدمات",
    "fa-FA": "نتایج خدمات",
    "de-DE": "Ergebnisse des Dienstes",
    "el": "Αποτελέσματα υπηρεσίας",
    "ha-HA": "Sakamakon sabis",
    "hu-HU": "Szolgáltatási eredmények",
    "it-IT": "Risultati del servizio",
    "KAU": "Sakamakon sabis",
    "ki-KI": "Maki maũkĩtĩ ya kĩhoto",
    "ln-LN": "Mbano ya mosala",
    "ps-PS": "د خدمتونو پایلې",
    "ru-RU": "Результаты услуг",
    "sw-SW": "Matokeo ya Huduma",
    "th": "ผลลัพธ์บริการ",
    "uk-UK": "Результати послуг"
},
resultsFor: {
    "en-US": "{count} results for {query}",
    am: "ለ {query} {count} ውጤቶች",
    "ar-SA": "{count} نتيجة لـ {query}",
    "fr-FR": "{count} résultats pour {query}",
    "es-ES": "{count} resultados para {query}",
    "so-SO": "{count} natiijooyinka loogu helay {query}",
    "ur-UR": "{count} نتائج {query} کے لیے",
    "ht": "{count} rezilta pou {query}",
    "fr-HT": "{count} rezilta pou {query}",
    "bn": "{count} টি ফলাফল {query} এর জন্য",
    "my": "{count} ရလဒ်များ {query} အတွက်",
    "cs": "{count} výsledků pro {query}",
    "fa-AF": "{count} نتیجه برای {query}",
    "fa-FA": "{count} نتیجه برای {query}",
    "de-DE": "{count} Ergebnisse für {query}",
    "el": "{count} αποτελέσματα για {query}",
    "ha-HA": "Sakamakon {count} na {query}",
    "hu-HU": "{count} találat erre: {query}",
    "it-IT": "{count} risultati per {query}",
    "KAU": "Sakamakon {count} na {query}",
    "ki-KI": "{count} maũkĩtĩ ya {query}",
    "ln-LN": "{count} mbano ya {query}",
    "ps-PS": "{count} پایلې د {query} لپاره",
    "ru-RU": "{count} результатов для {query}",
    "sw-SW": "Matokeo {count} ya {query}",
    "th": "ผลลัพธ์ {count} สำหรับ {query}",
    "uk-UK": "{count} результатів для {query}"
  },
noResultsToDisplay: {
    "en-US": "No Results To Display",
    am: "ለማሳየት ውጤት የለም",
    "ar-SA": "لا توجد نتائج لعرضها",
    "fr-FR": "Aucun résultat à afficher",
    "es-ES": "No hay resultados para mostrar",
    "so-SO": "Ma jiraan natiijooyin la soo bandhigayo",
    "ur-UR": "دکھانے کے لیے کوئی نتائج نہیں",
    "ht": "Pa gen Rezilta pou Montre",
    "fr-HT": "Pa gen Rezilta pou Montre",
    "bn": "প্রদর্শনের জন্য কোন ফলাফল নেই",
    "my": "ပြသရန် ရလဒ်များ မရှိပါ",
    "cs": "Žádné výsledky k zobrazení",
    "fa-AF": "هیچ نتیجه‌ای برای نمایش وجود ندارد",
    "fa-FA": "برای نمایش چیزی نیست",
    "de-DE": "Keine Ergebnisse anzuzeigen",
    "el": "Δεν υπάρχουν αποτελέσματα για εμφάνιση",
    "ha-HA": "Babu sakamako don nuna",
    "hu-HU": "Nincs megjeleníthető eredmény",
    "it-IT": "Nessun risultato da visualizzare",
    "KAU": "Babu sakamako don nuna",
    "ki-KI": "Nĩgũkũra thirikari",
    "ln-LN": "Mbano moko te mpo na kolakisa",
    "ps-PS": "ښودلو لپاره څه نشته",
    "ru-RU": "Нет результатов для отображения",
    "sw-SW": "Hakuna Matokeo ya Kuonyesha",
    "th": "ไม่มีผลลัพธ์ให้แสดง",
    "uk-UK": "Немає результатів для відображення"
},
resourcesCategories: {
    "en-US": "Resources Categories",
    am: "የመረጃ ምድቦች",
    "ar-SA": "فئات الموارد",
    "fr-FR": "Catégories de ressources",
    "es-ES": "Categorías de recursos",
    "so-SO": "Qeybaha Kheyraadka",
    "ur-UR": "وسائل کی اقسام",
    "ht": "Kategori Resous",
    "fr-HT": "Kategori Resous",
    "bn": "সম্পদ বিভাগ",
    "my": "အရင်းအမြစ်အမျိုးအစားများ",
    "cs": "Kategorie zdrojů",
    "fa-AF": "د منابع کټګورۍ",
    "fa-FA": "دسته‌بندی منابع",
    "de-DE": "Ressourcenkategorien",
    "el": "Κατηγορίες πόρων",
    "ha-HA": "Rukuni na kayan aiki",
    "hu-HU": "Erőforrás kategóriák",
    "it-IT": "Categorie di risorse",
    "KAU": "Rukuni na kayan aiki",
    "ki-KI": "Maki maũkĩtĩ ya ũhoro",
    "ln-LN": "Lolenge ya biloko ya mosala",
    "ps-PS": "د  سرچینو کټګورۍ",
    "ru-RU": "Категории ресурсов",
    "sw-SW": "Rasilimali za Kategoria",
    "th": "หมวดหมู่ทรัพยากร",
    "uk-UK": "Категорії ресурсів"
},
service_Types: {
    "en-US": "Service Category",
    am: "የአገልግሎት ምድብ",
    "ar-SA": "أنواع الخدمة",
    "fr-FR": "Types de service",
    "es-ES": "Tipos de servicio",
    "so-SO": "Noocyada Adeegyada",
    "ur-UR": "سروس کی اقسام",
    "ht": "Kalite Sèvis",
    "fr-HT": "Kalite Sèvis",
    "bn": " সেবার ধরণ",
    "my": "ဝန်ဆောင်မှုအမျိုးအစားများ",
    "cs": "Typy služeb",
    "fa-AF": "انواع خدمات",
    "fa-FA": "انواع خدمات",
    "de-DE": "Diensttypen",
    "el": "Τύποι υπηρεσιών",
    "ha-HA": "Nau'in sabis",
    "hu-HU": "Szolgáltatások típusa",
    "it-IT": "Tipi di servizio",
    "KAU": "Nau'in sabis",
    "ki-KI": "Maki maũkĩtĩ ya kĩhoto",
    "ln-LN": "Mitindo ya Misala",
    "ps-PS": "د خدمتونو ډولونه",
    "ru-RU": "Типы услуг",
    "sw-SW": "Aina za Huduma",
    "th": "ประเภทบริการ",
    "uk-UK": "Типи послуг"
},
of: {
    "en-US": "of",
    am: "ከ",
    "ar-SA": "ل",
    "fr-FR": "de",
    "es-ES": "de",
    "so-SO": "ka",
    "ur-UR": "کا",
    "ht": "de",
    "fr-HT": "de",
    "bn": "এর",
    "my": "၏",
    "cs": "z",
    "fa-AF": "از",
    "fa-FA": "از",
    "de-DE": "von",
    "el": "του",
    "ha-HA": "na",
    "hu-HU": "a",
    "it-IT": "di",
    "KAU": "na",
    "ki-KI": "ya",
    "ln-LN": "ya",
    "ps-PS": "د",
    "ru-RU": "из",
    "sw-SW": "ya",
    "th": "ของ",
    "uk-UK": "з"
},
services: {
    "en-US": "Services",
    am: "አገልግሎቶች",
    "ar-SA": "الخدمات",
    "fr-FR": "Services",
    "es-ES": "Servicios",
    "so-SO": "Adeegyada",
    "ur-UR": "خدمات",
    "ht": "Sèvis",
    "fr-HT": "Sèvis",
    "bn": " সেবা সমূহ",
    "my": "ဝန်ဆောင်မှုများ",
    "cs": "Služby",
    "fa-AF": "خدمات",
    "fa-FA": "خدمات",
    "de-DE": "Dienstleistungen",
    "el": "Υπηρεσίες",
    "ha-HA": "Ayyuka",
    "hu-HU": "Szolgáltatások",
    "it-IT": "Servizi",
    "KAU": "Ayyuka",
    "ki-KI": "Thirikari",
    "ln-LN": "Misala ya kosala",
    "ps-PS": "خدمتونه",
    "ru-RU": "Услуги",
    "sw-SW": "Huduma",
    "th": "บริการ",
    "uk-UK": "Послуги"
},
backToTop: {
    "en-US": "Back to Top",
    am: "ወደ ላይ ተመለስ",
    "ar-SA": "العودة إلى الأعلى",
    "fr-FR": "Retour au sommet",
    "es-ES": "Volver arriba",
    "so-SO": "Kor ugu noqo",
    "ur-UR": "اوپر واپس جائیں",
    "ht": "Retounen anwo a",
    "fr-HT": "Retounen anwo a",
    "bn": " উপরে আসুন",
    "my": "ထိပ်သို့ ပြန်လာပါ",
    "cs": "Zpět na začátek",
    "fa-AF": "به بالا برگردید",
    "fa-FA": "بازگشت به بالا",
    "de-DE": "Nach oben",
    "el": "Επιστροφή στην κορυφή",
    "ha-HA": "Komawa sama",
    "hu-HU": "Vissza a tetejére",
    "it-IT": "Torna su",
    "KAU": "Komawa sama",
    "ki-KI": "Gĩkũyũ kĩrĩ",
    "ln-LN": "Kozonga na Likolo",
    "ps-PS": "بېرته پورته",
    "ru-RU": "Вернуться к началу",
    "sw-SW": "Rudi Juu",
    "th": "กลับไปด้านบน",
    "uk-UK": "Повернутися на верх"
},
openingHours: {
    "en-US": "Opening Hours",
    am: "የመክፈቻ ሰዓቶች",
    "ar-SA": "ساعات العمل",
    "fr-FR": "Horaires d'ouvertures",
    "es-ES": "Horario de apertura",
    "so-SO": "saacadaha furitaanka",
    "ur-UR": "کھلنے کے اوقات",
    "ht": "Orè Ouverture",
    "fr-HT": "Orè Ouverture",
    "bn": "খোলার সময়",
    "my": "ဖွင့်ချိန်များ",
    "cs": "Otevírací hodiny",
    "fa-AF": "ساعات کار",
    "fa-FA": "ساعات کاری",
    "de-DE": "Öffnungszeiten",
    "el": "Ώρες λειτουργίας",
    "ha-HA": "Lokacin bude",
    "hu-HU": "Nyitvatartás",
    "it-IT": "Orari di apertura",
    "KAU": "Lokacin bude",
    "ki-KI": "Ndaraga",
    "ln-LN": "Bangonga ya Kofungola",
    "ps-PS": "کاري ساعتونه",
    "ru-RU": "Часы работы",
    "sw-SW": "Masaa ya kufunguliwa",
    "th": "เวลาทำการ",
    "uk-UK": "Години роботи"
},
cookiePolicy: {
    "en-US": "Cookie Policy",
    am: "የኩኪ ፖሊሲ",
    "fr-FR": "Politique de Cookies",
    "ar-SA": "سياسة الكوكيز",
    "es-ES": "Política de Cookies",
    "so-SO": "Siyaasadda Kukiyada",
    "ur-UR": "کوکیز کی پالیسی",
    "ht": "Règleman sou bonbon",
    "fr-HT": "Règleman sou bonbon",
    "bn": "কুকি নীতি।",
    "my": "ကူကီ မူဝါဒ",
    "cs": "Zásady cookies",
    "fa-AF": "سیاست کوکی",
    "fa-FA": "پالیسی کوکی‌ها",
    "de-DE": "Cookie-Richtlinie",
    "el": "Πολιτική για τα cookies",
    "ha-HA": "Ka'idojin Kukis",
    "hu-HU": "Cookie-szabályzat",
    "it-IT": "Informativa sui cookie",
    "KAU": "Ka'idojin Kukis",
    "ki-KI": "Mũnĩtũ wa kĩhũũ",
    "ln-LN": "Kangá na motó makambo oyo olingaka",
    "ps-PS": "د کوکي پاليسي",
    "ru-RU": "Политика в отношении файлов cookie",
    "sw-SW": "Sera ya Vidakuzi",
    "th": "นโยบายคุกกี้",
    "uk-UK": "Політика щодо файлів cookie"
},
accept: {
    "en-US": "Accept",
    am: "ተቀበል",
    "fr-FR": "Accepter",
    "ar-SA": "قبول",
    "es-ES": "Aceptar",
    "so-SO": "Aqbal",
    "ur-UR": "قبول کریں",
    "ht": "Aksepte",
    "fr-HT": "Aksepte",
    "bn": "গ্রহণ করা",
    "my": "လက်ခံပါ",
    "cs": "Akceptovat",
    "fa-AF": "قبول کنید",
    "fa-FA": "تایید",
    "de-DE": "Akzeptieren",
    "el": "Αποδοχή",
    "ha-HA": "A yarda",
    "hu-HU": "Elfogad",
    "it-IT": "Accetta",
    "KAU": "A yarda",
    "ki-KI": "Wĩkĩrĩ",
    "ln-LN": "Kondima",
    "ps-PS": "تایید",
    "ru-RU": "Принять",
    "sw-SW": "Kubali",
    "th": "ยอมรับ",
    "uk-UK": "Прийняти"
},
decline: {
    "en-US": "Decline",
    am: "አትቀበል",
    "fr-FR": "Refuser",
    "ar-SA": "رفض",
    "es-ES": "Rechazar",
    "so-SO": "Diid",
    "ur-UR": "مسترد کریں",
    "ht": "Refize",
    "fr-HT": "Refize",
    "bn": "প্রত্যাখ্যান করা",
    "my": "ထုတ်ပယ်ပါ",
    "cs": "Odmítnout",
    "fa-AF": "رد کنید",
    "fa-FA": "رد",
    "de-DE": "Ablehnen",
    "el": "Απόρριψη",
    "ha-HA": "Ki ƙi",
    "hu-HU": "Elutasít",
    "it-IT": "Rifiuta",
    "KAU": "Ki ƙi",
    "ki-KI": "Ngwĩrĩ",
    "ln-LN": "Koboya",
    "ps-PS": "رد",
    "ru-RU": "Отклонить",
    "sw-SW": "Kataa",
    "th": "ปฏิเสธ",
    "uk-UK": "Відхилити"
},
name: {
    "en-US": "Name",
    am: "ስም",
    "fr-FR": "Nom",
    "ar-SA": "الاسم",
    "es-ES": "Nombre",
    "so-SO": "Magaca",
    "ur-UR": "نام",
    "ht": "Non",
    "fr-HT": "Non",
    "bn": "নাম",
    "my": "အမည်",
    "cs": "Jméno",
    "fa-AF": "نام",
    "fa-FA": "نام",
    "de-DE": "Name",
    "el": "Όνομα",
    "ha-HA": "Sunan",
    "hu-HU": "Név",
    "it-IT": "Nome",
    "KAU": "Sunan",
    "ki-KI": "Jina",
    "ln-LN": "Mokonzi",
    "ps-PS": "نوم",
    "ru-RU": "Имя",
    "sw-SW": "Jina",
    "th": "ชื่อ",
    "uk-UK": "Ім'я"
},
message: {
    "en-US": "Message",
    am: "መልእክት",
    "fr-FR": "Message",
    "ar-SA": "رسالة",
    "es-ES": "Mensaje",
    "so-SO": "Fariin",
    "ur-UR": "پیغام",
    "ht": "Mesaj",
    "fr-HT": "Mesaj",
    "bn": "বার্তা",
    "my": "မက်ဆေ့",
    "cs": "Zpráva",
    "fa-AF": "پیام",
    "fa-FA": "پیام",
    "de-DE": "Nachricht",
    "el": "Μήνυμα",
    "ha-HA": "Rubutu",
    "hu-HU": "Üzenet",
    "it-IT": "Messaggio",
    "KAU": "Rubutu",
    "ki-KI": "Mũhiki",
    "ln-LN": "Mokonzi",
    "ps-PS": "پیغام",
    "ru-RU": "Сообщение",
    "sw-SW": "Ujumbe",
    "th": "ข้อความ",
    "uk-UK": "Повідомлення"
},
submit: {
    "en-US": "Submit",
    am: "ላክ",
    "fr-FR": "Soumettre",
    "ar-SA": "إرسال",
    "es-ES": "Enviar",
    "so-SO": "Dir",
    "ur-UR": "جمع کرائیں",
    "ht": "Soumèt",
    "fr-HT": "Soumèt",
    "bn": "জমা দিন",
    "my": "တင်သွင်းပါ",
    "cs": "Odeslat",
    "fa-AF": "ارسال",
    "fa-FA": "ارسال",
    "de-DE": "Einreichen",
    "el": "Υποβολή",
    "ha-HA": "Aika",
    "hu-HU": "Küldés",
    "it-IT": "Invia",
    "KAU": "Aika",
    "ki-KI": "Thutha",
    "ln-LN": "Kokoma",
    "ps-PS": "پیژندل",
    "ru-RU": "Отправить",
    "sw-SW": "Tuma",
    "th": "ส่ง",
    "uk-UK": "Надіслати"
},
contactForm: {
    "en-US": "Contact Form",
    am: "የመገናኛ ቅጽ",
    "fr-FR": "Formulaire de contact",
    "ar-SA": "نموذج الاتصال",
    "es-ES": "Contacto",
    "so-SO": "Foomka Xiriirka",
    "ur-UR": "رابطہ فارم",
    "ht": "Fòm kontak",
    "fr-HT": "Fòm kontak",
    "bn": "যোগাযোগ ফর্ম",
    "my": "ဆက်သွယ်ပါ",
    "cs": "Kontaktní formulář",
    "fa-AF": "فرم تماس",
    "fa-FA": "فرم تماس",
    "de-DE": "Kontaktformular",
    "el": "Φόρμα επικοινωνίας",
    "ha-HA": "Foom din",
    "hu-HU": "Kapcsolatfelvételi űrlap",
    "it-IT": "Modulo di contatto",
    "KAU": "Foom din",
    "ki-KI": "Fomu ya kuhitiri",
    "ln-LN": "Fòm kontak",
    "ps-PS": "د رابطه فورم",
    "ru-RU": "Форма обратной связи",
    "sw-SW": "Fomu ya Mawasiliano",
    "th": "แบบฟอร์มติดต่อ",
    "uk-UK": "Форма зворотнього зв'язку"
},
contactFormDescription: {
    "en-US": "Fill out our form with your query, and we will get back to you as promptly as possible",
    am: "ጥያቄዎን በቅጹ ላይ ይሙሉ፣ በተቻለ ፍጥነት እንመልስልዎታለን",
    "ar-SA": "املأ نموذجنا باستفسارك، وسنعاود الاتصال بك في أقرب وقت ممكن",
    "fr-FR": "Remplissez notre formulaire avec votre demande, et nous vous répondrons dans les plus brefs délais",
    "es-ES": "¿Tienes alguna duda? Envíanos tu consulta y nos pondremos en contacto contigo lo más pronto posible",
    "so-SO": "Buuxi foomkayaga su'aashaada, waxaanan kuugu soo jawaabi doonaa sida ugu dhaqsaha badan",
    "ur-UR": "اپنی استفسار کے ساتھ ہمارا فارم پُر کریں، اور ہم جلد از جلد آپ سے رابطہ کریں گے",
    "ht": "Ranpli fòm nou an ak kesyon ou, epi nou pral kontakte ou pi vit ke posib",
    "bn": "আপনার প্রশ্ন সহ আমাদের ফর্মটি পূরণ করুন, এবং আমরা যত তাড়াতাড়ি সম্ভব আপনার সাথে যোগাযোগ করব",
    "my": "သင့်မေးခွန်းနှင့်အတူ ကျွန်ုပ်တို့၏ပုံစံကို ဖြည့်စွက်ပါ၊ ကျွန်ုပ်တို့သည် အမြန်ဆုံး သင့်ထံ ပြန်လည်ဆက်သွယ်ပါမည်",
    "cs": "Vyplňte náš formulář s vaším dotazem a my se vám co nejdříve ozveme",
    "fa-AF": "فرم ما را با پرسش خود پر کنید و ما در اسرع وقت با شما تماس خواهیم گرفت",
    "fa-FA": "فرم ما را با پرسش خود پر کنید و ما در اسرع وقت با شما تماس خواهیم گرفت",
    "de-DE": "Füllen Sie unser Formular mit Ihrer Anfrage aus, und wir werden uns so schnell wie möglich bei Ihnen melden",
    "el": "Συμπληρώστε τη φόρμα μας με το ερώτημά σας και θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό",
    "ha-HA": "Cika fom ɗin mu da tambayar ku, kuma za mu dawo muku da wuri-wuri",
    "hu-HU": "Töltse ki űrlapunkat kérdésével, és a lehető leghamarabb visszajelzünk",
    "it-IT": "Compila il nostro modulo con la tua richiesta e ti risponderemo il prima possibile",
    "KAU": "Cika fom ɗin mu da tambayar ku, kuma za mu dawo muku da wuri-wuri",
    "ki-KI": "Jaza fomu yetu na swali lako, na tutakujibu haraka iwezekanavyo",
    "ln-LN": "Tondisa fòm na biso na motuna na yo, mpe tokobanga yo na ntango ya kala te",
    "ps-PS": "زموږ فارم د خپل پوښتنې سره ډک کړئ، او موږ به ژر تر ژره تاسو ته ځواب ووایو",
    "ru-RU": "Заполните нашу форму с вашим запросом, и мы свяжемся с вами как можно скорее",
    "sw-SW": "Jaza fomu yetu na swali lako, na tutakujibu haraka iwezekanavyo",
    "th": "กรอกแบบฟอร์มของเราพร้อมคำถามของคุณ และเราจะติดต่อกลับโดยเร็วที่สุด",
    "uk-UK": "Заповніть нашу форму з вашим запитом, і ми зв'яжемося з вами якомога швидше"
},
yourMessageHere: {
    "en-US": "Your message here...",
    am: "መልእክትዎ እዚህ...",
    "fr-FR": "Votre message ici...",
    "ar-SA": "رسالتك هنا...",
    "es-ES": "Tu mensaje aquí...",
    "so-SO": "Fariintaaga halkan...",
    "ur-UR": "آپ کا پیغام یہاں...",
    "ht": "Mesaj ou la...",
    "fr-HT": "Mesaj ou la...",
    "bn": "আপনার বার্তা এখানে...",
    "my": "သင့်မက်ဆေ့ဒါများဒါများ...",
    "cs": "Vaše zpráva zde...",
    "fa-AF": "پیام شما اینجا...",
    "fa-FA": "پیام شما اینجا...",
    "de-DE": "Ihre Nachricht hier...",
    "el": "Το μήνυμά σας εδώ...",
    "ha-HA": "Rubutunka nan...",
    "hu-HU": "Az üzeneted itt...",
    "it-IT": "Il tuo messaggio qui...",
    "KAU": "Rubutunka nan...",
    "ki-KI": "Mũhiki wako hapa...",
    "ln-LN": "Mokonzi na yo...",
    "ps-PS": "ستاسو پیغام دا...",
    "ru-RU": "Ваше сообщение здесь...",
    "sw-SW": "Ujumbe wako hapa...",
    "th": "ข้อความของคุณที่นี่...",
    "uk-UK": "Ваше повідомлення тут..."
},
sent: {
    "en-US": "Sent",
    am: "ተልኳል",
    "fr-FR": "Envoyé",
    "ar-SA": "تم الإرسال",
    "es-ES": "Enviado",
    "so-SO": "La diray",
    "ur-UR": "بھیج دیا گیا",
    "ht": "Voye",
    "fr-HT": "Voye",
    "bn": "প্রেরিত",
    "my": "ပို့ပြီ",
    "cs": "Odesláno",
    "fa-AF": "ارسال شد",
    "fa-FA": "ارسال شد",
    "de-DE": "Gesendet",
    "el": "Απεστάλη",
    "ha-HA": "An kai",
    "hu-HU": "Elküldve",
    "it-IT": "Inviato",
    "KAU": "An kai",
    "ki-KI": "Imwe",
    "ln-LN": "Kosala",
    "ps-PS": "پیغام رسول",
    "ru-RU": "Отправлено",
    "sw-SW": "Imetumwa",
    "th": "ส่งแล้ว",
    "uk-UK": "Відправлено"
},
contactUs: {
    "en-US": "Contact Us",
    am: "ያግኙን",
    "fr-FR": "Contactez-nous",
    "ar-SA": "اتصل بنا",
    "es-ES": "Contáctanos",
    "so-SO": "Nala soo xiriir",
    "ur-UR": "ہم سے رابطہ کریں",
    "ht": "Kontakte nou",
    "fr-HT": "Kontakte nou",
    "bn": "যোগাযোগ করুন",
    "my": "ဆက်သွယ်ပါ",
    "cs": "Kontaktujte nás",
    "fa-AF": "با ما تماس بگیرید",
    "fa-FA": "با ما تماس بگیرید",
    "de-DE": "Kontaktiere uns",
    "el": "Επικοινωνήστε μαζί μας",
    "ha-HA": "Tuntuɓi mu",
    "hu-HU": "Lépjen kapcsolatba velünk",
    "it-IT": "Contattaci",
    "KAU": "Tuntuɓi mu",
    "ki-KI": "Tumikirire na",
    "ln-LN": "Kosala na biso",
    "ps-PS": "موندل",
    "ru-RU": "Свяжитесь с нами",
    "sw-SW": "Wasiliana nasi",
    "th": "ติดต่อเรา",
    "uk-UK": "Зв'яжіться з нами"
},
subject: {
    "en-US": "Subject",
    am: "ርዕሰ ጉዳይ",
    "fr-FR": "Sujet",
    "ar-SA": "الموضوع",
    "es-ES": "Asunto",
    "so-SO": "Mawduuc",
    "ur-UR": "موضوع",
    "ht": "Sijè",
    "fr-HT": "Sijè",
    "bn": "বিষয়",
    "my": "အကြောင်း",
    "cs": "Předmět",
    "fa-AF": "موضوع",
    "fa-FA": "موضوع",
    "de-DE": "Betreff",
    "el": "Θέμα",
    "ha-HA": "Mawaki",
    "hu-HU": "Tárgy",
    "it-IT": "Oggetto",
    "KAU": "Mawaki",
    "ki-KI": "Mũhiki",
    "ln-LN": "Mokonzi",
    "ps-PS": "موضوع",
    "ru-RU": "Тема",
    "sw-SW": "Mada",
    "th": "เรื่อง",
    "uk-UK": "Тема"
},
subjectPlaceholder: {
    "en-US": "Subject of your message",
    am: "የመልእክትዎ ርዕሰ ጉዳይ",
    "fr-FR": "Sujet de votre message",
    "ar-SA": "موضوع رسالتك",
    "es-ES": "Asunto de tu mensaje",
    "so-SO": "Mawduuca farriintaada",
    "ur-UR": "آپ کے پیغام کا موضوع",
    "ht": "Sijè mesaj ou",
    "fr-HT": "Sijè mesaj ou",
    "bn": "আপনার বার্তার বিষয়",
    "my": "သင့်မက်ဆေ့ခ်ျ၏ခေါင်းစဉ်",
    "cs": "Předmět vaší zprávy",
    "fa-AF": "موضوع پیام شما",
    "fa-FA": "موضوع پیام شما",
    "de-DE": "Betreff Ihrer Nachricht",
    "el": "Θέμα του μηνύματός σας",
    "ha-HA": "Jigon saƙon ku",
    "hu-HU": "Üzenete tárgya",
    "it-IT": "Oggetto del tuo messaggio",
    "KAU": "Mawaki",
    "ki-KI": "Mũhiki",
    "ln-LN": "Mokonzi",
    "ps-PS": "د پیغام موضوع",
    "ru-RU": "Тема вашего сообщения",
    "sw-SW": "Kichwa cha ujumbe wako",
    "th": "หัวข้อของข้อความของคุณ",
    "uk-UK": "Тема вашого повідомлення"
},
locations: {
    "en-US": "Locations",
    am: "ቦታዎች",
    "ar-SA": "المواقع",
    "fr-FR": "Lieux",
    "es-ES": "Ubicaciones",
    "so-SO": "Goobaha",
    "ur-UR": "مقامات",
    "ht": "Kote",
    "fr-HT": "Kote",
    "bn": "অবস্থানগুলি",
    "my": "ရာထူးများ",
    "cs": "Místa",
    "fa-AF": "مناطق",
    "fa-FA": "موقعیت‌ها",
    "de-DE": "Standorte",
    "el": "Τοποθεσίες",
    "ha-HA": "Wurare",
    "hu-HU": "Helyszínek",
    "it-IT": "Luoghi",
    "KAU": "Wurare",
    "ki-KI": "Mihoya",
    "ln-LN": "Bisika oyo ezali",
    "ps-PS": "ځایونه",
    "ru-RU": "Места",
    "sw-SW": "Maeneo",
    "th": "สถานที่",
    "uk-UK": "Локації"
},
allLocations: {
    "en-US": "All Locations",
    am: "ሁሉም ቦታዎች",
    "ar-SA": "جميع المواقع",
    "fr-FR": "Tous les Lieux",
    "es-ES": "Todas las ubicaciones",
    "so-SO": "Dhammaan Goobaha",
    "ur-UR": "تمام مقامات",
    "ht": "Tout kote",
    "fr-HT": "Tout kote",
    "bn": "সমস্ত অবস্থান",
    "my": "အားလုံးအဆောက်အဦးများ",
    "cs": "Všechna místa",
    "fa-AF": "همه مناطق",
    "fa-FA": "همه موقعیت‌ها",
    "de-DE": "Alle Standorte",
    "el": "Όλες οι τοποθεσίες",
    "ha-HA": "Duk wurare",
    "hu-HU": "Minden helyszín",
    "it-IT": "Tutti i luoghi",
    "KAU": "Duk wurare",
    "ki-KI": "Mihoya Yote",
    "ln-LN": "Bisika oyo ezali nyoso",
    "ps-PS": "ټول ځایونه",
    "ru-RU": "Все места",
    "sw-SW": "Maeneo Yote",
    "th": "ทุกสถานที่",
    "uk-UK": "Усі локації"
},
pageNotAvailable: {
    "en-US": "The page you were looking for is not yet available. Please check back later as we are working on translating this page.",
    am: "የሚፈልጉት ገጽ ገና አልተዘጋጀም። ይህን ገጽ በመተርጎም ላይ ስለሆንን እባክዎ ቆይተው እንደገና ይመልከቱ።",
    "ar-SA": "الصفحة التي تبحث عنها غير متوفرة بعد. يرجى العودة لاحقًا حيث نعمل على ترجمة هذه الصفحة.",
    "fr-FR": "La page que vous recherchez n'est pas encore disponible. Veuillez revenir plus tard car nous travaillons sur la traduction de cette page.",
    "es-ES": "La página que buscabas aún no está disponible. Por favor, vuelve más tarde mientras trabajamos en traducir esta página.",
    "so-SO": "Bogga aad raadinaysay wali lama heli karo. Fadlan dib u hubi goor dambe maaddaama aan ka shaqeyneyno turjumaadda boggan.",
    "ur-UR": "جس صفحہ کی آپ تلاش کر رہے تھے وہ ابھی دستیاب نہیں ہے۔ براہ کرم بعد میں دوبارہ چیک کریں کیونکہ ہم اس صفحے کا ترجمہ کر رہے ہیں۔",
    "ht": "Paj la ou t ap chèche a poko disponib. Tanpri retounen pita pandan n ap travay sou tradiksyon paj sa a.",
    "fr-HT": "Paj la ke ou te chèche a poko disponib. Tanpri retounen pita pandan nap travay sou tradiksyon paj sa a.",
    "bn": "আপনি যে পৃষ্ঠাটি খুঁজছিলেন তা এখনও উপলভ্য নয়। আমরা এই পৃষ্ঠাটির অনুবাদে কাজ করছি, দয়া করে পরে আবার দেখুন।",
    "my": "ရှာဖွေနေသောစာမျက်နှာသည်အခုတစ်ချိန်တွင်ရရှိနိုင်ပါသေး။ ဤစာမျက်နှာကိုဘာသာပြန်နေသောကြောင့်ခဏစောင့်ပေးပါ။",
    "cs": "Stránka, kterou hledáte, ještě není k dispozici. Zkuste to prosím později, protože pracujeme na překladu této stránky.",
    "fa-AF": "صفحه‌ای که به دنبال آن بودید هنوز در دسترس نیست. لطفاً بعداً بررسی کنید زیرا ما در حال ترجمه این صفحه هستیم.",
    "fa-FA": "صفحه‌ای که به دنبال آن بودید هنوز در دسترس نیست. لطفاً بعداً بررسی کنید زیرا ما در حال ترجمه این صفحه هستیم.",
    "de-DE": "Die Seite, die Sie gesucht haben, ist noch nicht verfügbar. Bitte schauen Sie später noch einmal vorbei, da wir an der Übersetzung dieser Seite arbeiten.",
    "el": "Η σελίδα που αναζητούσατε δεν είναι ακόμη διαθέσιμη. Παρακαλούμε ελέγξτε ξανά αργότερα, καθώς εργαζόμαστε για τη μετάφραση αυτής της σελίδας.",
    "ha-HA": "Bayanin da kake nema yanzu ba ya nan. Da fatan za a sake duba baya bayan an gama fassara wannan shafi.",
    "hu-HU": "Az oldal, amelyet keresett, még nem elérhető. Kérjük, térjen vissza később, mivel dolgozunk ennek az oldalnak a fordításán.",
    "it-IT": "La pagina che stavi cercando non è ancora disponibile. Si prega di ricontrollare più tardi, poiché stiamo lavorando alla traduzione di questa pagina.",
    "KAU": "Shafin da kake nema yanzu ba ya nan. Da fatan za a sake duba baya bayan an gama fassara wannan shafi.",
    "ki-KI": "Ukurasa ambao ulikuwa unatafuta bado haupatikani. Tafadhali rudi baadaye tunapofanya kazi ya kutafsiri ukurasa huu.",
    "ln-LN": "Lokasa oyo olingaki ezali naino te. Tika ete ozonga sima, mpo tozali kosala na kotambola lokasa oyo.",
    "ps-PS": "هغه پاڼه چې تاسو یې په لټه کې یاست، لاهم شتون نلري. مهرباني وکړئ وروسته بیا وګورئ ځکه چې موږ د دې پاڼې ژباړلو کې یو.",
    "ru-RU": "Страница, которую вы искали, пока недоступна. Пожалуйста, зайдите позже, так как мы работаем над переводом этой страницы.",
    "sw-SW": "Ukurasa ambao ulikuwa unatafuta haupatikani. Tafadhali rudi baadaye tunapofanya kazi ya kutafsiri ukurasa huu.",
    "th": "หน้าที่คุณกำลังค้นหายังไม่พร้อมใช้งาน กรุณาตรวจสอบอีกครั้งในภายหลังเนื่องจากเรากำลังดำเนินการแปลหน้านี้",
    "uk-UK": "Сторінка, яку ви шукали, ще не доступна. Будь ласка, перевірте пізніше, оскільки ми працюємо над перекладом цієї сторінки."
},
sorry: {
  "en-US": "Sorry",
  am: "ይቅርታ",
  "ar-SA": "عذرًا",
  "fr-FR": "Désolé",
  "es-ES": "Lo siento",
  "so-SO": "Waan ka xumahay",
  "ur-UR": "معذرت",
  "ht": "Padon",
  "fr-HT": "Padon",
  "bn": "দুঃখিত",
  "my": "တောင်းပန်ပါတယ်",
  "cs": "Promiňte",
  "fa-AF": "ببخشید",
  "fa-FA": "ببخشید",
  "de-DE": "Entschuldigung",
  "el": "Συγγνώμη",
  "ha-HA": "Yi haƙuri",
  "hu-HU": "Elnézést",
  "it-IT": "Scusa",
  "KAU": "Yi haƙuri",
  "ki-KI": "Samahani",
  "ln-LN": "Pardon",
  "ps-PS": "بخښنه غواړم",
  "ru-RU": "Извините",
  "sw-SW": "Pole",
  "th": "ขอโทษ",
  "uk-UK": "Вибачте"
},
oops: {
  "en-US": "Oops",
  am: "ውይ",
  "ar-SA": "عذرًا",
  "fr-FR": "Oups",
  "es-ES": "Vaya",
  "so-SO": "Oh",
  "ur-UR": "اوہ",
  "ht": "Oups",
  "fr-HT": "Oups",
  "bn": "ওহো",
  "my": "အင်း",
  "cs": "Jéje",
  "fa-AF": "اوه",
  "fa-FA": "اوه",
  "de-DE": "Hoppla",
  "el": "Ουπς",
  "ha-HA": "Ihuuu",
  "hu-HU": "Hoppá",
  "it-IT": "Ops",
  "KAU": "Ihuuu",
  "ki-KI": "Oo",
  "ln-LN": "Yeh",
  "ps-PS": "اه",
  "ru-RU": "Упс",
  "sw-SW": "Oo",
  "th": "อุ๊ย",
  "uk-UK": "Ой"
},
pageNotExist: {
  "en-US": "Sorry, the page you're trying to visit does not exist.",
  am: "ይቅርታ፣ ለመጎብኘት የሞከሩት ገጽ የለም።",
  "ar-SA": "عذرًا، الصفحة التي تحاول زيارتها غير موجودة.",
  "fr-FR": "Désolé, la page que vous essayez de visiter n'existe pas.",
  "es-ES": "Lo siento, la página que intentas visitar no existe.",
  "so-SO": "Waan ka xumahay, bogga aad isku dayaysid inaad booqato ma jiro.",
  "ur-UR": "معذرت، آپ جس صفحے کو دیکھنے کی کوشش کر رہے ہیں وہ موجود نہیں ہے۔",
  "ht": "Padon, paj la ou ap eseye vizite a pa egziste.",
  "fr-HT": "Padon, paj la ou ap eseye vizite a pa egziste.",
  "bn": "দুঃখিত, আপনি যে পৃষ্ঠাটি দেখার চেষ্টা করছেন সেটি নেই।",
  "my": "ဝမ်းနည်းပါတယ်၊ သင့်အနေဖြင့်အလည်အပတ်လုပ်နေသောစာမျက်နှာ မရှိပါ။",
  "cs": "Promiňte, stránka, kterou se snažíte navštívit, neexistuje.",
  "fa-AF": "ببخشید، صفحه‌ای که می‌خواهید بازدید کنید وجود ندارد.",
  "fa-FA": "ببخشید، صفحه‌ای که می‌خواهید بازدید کنید وجود ندارد.",
  "de-DE": "Entschuldigung, die Seite, die Sie besuchen möchten, existiert nicht.",
  "el": "Συγγνώμη, η σελίδα που προσπαθείτε να επισκεφτείτε δεν υπάρχει.",
  "ha-HA": "Yi haƙuri, shafin da kake ƙoƙarin ziyarta babu shi.",
  "hu-HU": "Sajnáljuk, az oldal, amelyet meg szeretne látogatni, nem létezik.",
  "it-IT": "Spiacenti, la pagina che stai tentando di visitare non esiste.",
  "KAU": "Yi haƙuri, shafin da kake ƙoƙarin ziyarta babu shi.",
  "ki-KI": "Pole, ukurasa unaojaribu kutembelea haupo.",
  "ln-LN": "Pardon, lokasa oyo olingi kotala ezali te.",
  "ps-PS": "بخښنه غواړم، هغه پاڼه چې تاسو یې لیدلو هڅه کوئ شتون نلري.",
  "ru-RU": "Извините, страница, которую вы пытаетесь посетить, не существует.",
  "sw-SW": "Pole, ukurasa unaojaribu kutembelea haupo.",
  "th": "ขอโทษ หน้าที่คุณพยายามเข้าชมไม่มีอยู่",
  "uk-UK": "Вибачте, сторінка, яку ви намагаєтесь відвідати, не існує."
},
navigateHome: {
  "en-US": "Navigate back to home",
  am: "ወደ መነሻ ተመለስ",
  "ar-SA": "العودة إلى الصفحة الرئيسية",
  "fr-FR": "Retourner à l'accueil",
  "es-ES": "Regresar al inicio",
  "so-SO": "Ku laabo guriga",
  "ur-UR": "مرکزی صفحے پر جائیں",
  "ht": "Retounen nan paj prensipal la",
  "fr-HT": "Retounen nan paj prensipal la",
  "bn": "হোমে ফিরে যান",
  "my": "ပင်မစာမျက်နှာသို့ ပြန်သွားရန်",
  "cs": "Vrátit se na domovskou stránku",
  "fa-AF": "بازگشت به صفحه اصلی",
  "fa-FA": "بازگشت به صفحه اصلی",
  "de-DE": "Zurück zur Startseite",
  "el": "Επιστροφή στην αρχική σελίδα",
  "ha-HA": "Komawa gida",
  "hu-HU": "Vissza a főoldalra",
  "it-IT": "Torna alla home",
  "KAU": "Komawa gida",
  "ki-KI": "Rudi nyumbani",
  "ln-LN": "Zonga na ebandeli",
  "ps-PS": "کور ته بیرته لاړ شئ",
  "ru-RU": "Вернуться на главную",
  "sw-SW": "Rudi nyumbani",
  "th": "กลับไปที่หน้าแรก",
  "uk-UK": "Повернутися на головну сторінку"
},
subjectOfYourMessage: {
    "en-US": "Subject of your message",
    am: "የመልእክትዎ ርዕሰ ጉዳይ",
    "ar-SA": "موضوع رسالتك",
    "fr-FR": "Sujet de votre message",
    "es-ES": "Asunto de tu mensaje",
    "so-SO": "Mawduuciga fariintaaga",
    "ur-UR": "آپ کے پیغام کا موضوع",
    "ht": "Sijè mesaj ou",
    "fr-HT": "Sijè mesaj ou",
    "bn": "আপনার বার্তার বিষয়",
    "my": "သင့်မေးခွန်းအကြောင်း",
    "cs": "Předmět vaší zprávy",
    "fa-AF": "موضوع پیام شما",
    "fa-FA": "موضوع پیام شما",
    "de-DE": "Betreff Ihrer Nachricht",
    "el": "Θέμα του μηνύματός σας",
    "ha-HA": "Mawaki na fariinta",
    "hu-HU": "Az üzenete tárgya",
    "it-IT": "Oggetto del tuo messaggio",
    "KAU": "Mawaki na fariinta",
    "ki-KI": "Mũhiki wa mũhiki wako",
    "ln-LN": "Mokonzi ya mokonzi na yo",
    "ps-PS": "موضوع د پیغام یا",
    "ru-RU": "Тема вашего сообщения",
    "sw-SW": "Mada ya ujumbe wako",
    "th": "เรื่องของข้อความของคุณ",
    "uk-UK": "Тема вашого повідомлення"
},
email: {
    "ar-SA": "البريد الإلكتروني",
    "bn": "ইমেইল",
    "my": "အီးမေးလ်",
    "cs": "E-mail",
    "fa-AF": "ایمیل",
    "en-US": "Email",
    am: "ኢሜይል",
    "fa-FA": "ایمیل",
    "fr-FR": "E-mail",
    "de-DE": "E-Mail",
    "el": "Ηλεκτρονικό ταχυδρομείο",
    "ht": "Imèl",
    "fr-HT": "Imèl",
    "ha-HA": "Imel",
    "hu-HU": "E-mail",
    "it-IT": "E-mail",
    "KAU": "Imel",
    "ki-KI": "Imeri",
    "ln-LN": "Imɛlɛ",
    "ps-PS": "برېښنالیک",
    "ru-RU": "Электронная почта",
    "so-SO": "Iimayl",
    "es-ES": "Correo electrónico",
    "sw-SW": "Barua pepe",
    "th": "อีเมล",
    "uk-UK": "Електронна пошта",
    "ur-UR": "ای میل"
},

Sunday: {
      "en-US": "Sunday",
      am: "እሁድ",
      "ar-SA": "الأحد",
      "fr-FR": "Dimanche",
      "es-ES": "Domingo",
      "so-SO": "Axad",
      "ur-UR": "اتوار",
      "ht": "Dimanch",
      "fr-HT": "Dimanch",
      "bn": "রবিবার",
      "my": "တနင်္ဂနွေ",
      "cs": "Neděle",
      "fa-AF": "یک‌شنبه",
      "fa-FA": "یک‌شنبه",
      "de-DE": "Sonntag",
      "el": "Κυριακή",
      "ha-HA": "Lahadi",
      "hu-HU": "Vasárnap",
      "it-IT": "Domenica",
      "KAU": "Lahadi",
      "ki-KI": "Kiumia",
      "ln-LN": "Lomingo",
      "ps-PS": "یکشنبه",
      "ru-RU": "Воскресенье",
      "sw-SW": "Jumapili",
      "th": "วันอาทิตย์",
      "uk-UK": "Неділя"
    },
 Monday: {
      "en-US": "Monday",
      am: "ሰኞ",
      "ar-SA": "الاثنين",
      "fr-FR": "Lundi",
      "es-ES": "Lunes",
      "so-SO": "Isniin",
      "ur-UR": "پیر",
      "ht": "Lendi",
      "fr-HT": "Lendi",
      "bn": "সোমবার",
      "my": "တနင်္လာ",
      "cs": "Pondělí",
      "fa-AF": "دوشنبه",
      "fa-FA": "دوشنبه",
      "de-DE": "Montag",
      "el": "Δευτέρα",
      "ha-HA": "Litinin",
      "hu-HU": "Hétfő",
      "it-IT": "Lunedì",
      "KAU": "Litinin",
      "ki-KI": "Mbiritho",
      "ln-LN": "Lundi",
      "ps-PS": "دوشنبه",
      "ru-RU": "Понедельник",
      "sw-SW": "Jumatatu",
      "th": "วันจันทร์",
      "uk-UK": "Понеділок"
    },
Tuesday: {
      "en-US": "Tuesday",
      am: "ማክሰኞ",
      "ar-SA": "الثلاثاء",
      "fr-FR": "Mardi",
      "es-ES": "Martes",
      "so-SO": "Talaado",
      "ur-UR": "منگل",
      "ht": "Madi",
      "fr-HT": "Madi",
      "bn": "মঙ্গলবার",
      "my": "အင်္ဂါ",
      "cs": "Úterý",
      "fa-AF": "سه‌شنبه",
      "fa-FA": "سه‌شنبه",
      "de-DE": "Dienstag",
      "el": "Τρίτη",
      "ha-HA": "Talata",
      "hu-HU": "Kedd",
      "it-IT": "Martedì",
      "KAU": "Talata",
      "ki-KI": "Kiumia wa Kairi",
      "ln-LN": "Mardi",
      "ps-PS": "سه‌شنبه",
      "ru-RU": "Вторник",
      "sw-SW": "Jumanne",
      "th": "วันอังคาร",
      "uk-UK": "Вівторок"
    },
Wednesday: {
      "en-US": "Wednesday",
      am: "ረቡዕ",
      "ar-SA": "الأربعاء",
      "fr-FR": "Mercredi",
      "es-ES": "Miércoles",
      "so-SO": "Arbaco",
      "ur-UR": "بدھ",
      "ht": "Mèkredi",
      "fr-HT": "Mèkredi",
      "bn": "বুধবার",
      "my": "ဗုဒ္ဓဟူး",
      "cs": "Středa",
      "fa-AF": "چهارشنبه",
      "fa-FA": "چهارشنبه",
      "de-DE": "Mittwoch",
      "el": "Τετάρτη",
      "ha-HA": "Laraba",
      "hu-HU": "Szerda",
      "it-IT": "Mercoledì",
      "KAU": "Laraba",
      "ki-KI": "Kiumia wa Kegiri",
      "ln-LN": "Mercredi",
      "ps-PS": "چهارشنبه",
      "ru-RU": "Среда",
      "sw-SW": "Jumatano",
      "th": "วันพุธ",
      "uk-UK": "Середа"
    },
Thursday: {
      "en-US": "Thursday",
      am: "ሐሙስ",
      "ar-SA": "الخميس",
      "fr-FR": "Jeudi",
      "es-ES": "Jueves",
      "so-SO": "Khamiis",
      "ur-UR": "جمعرات",
      "ht": "Jedi",
      "fr-HT": "Jedi",
      "bn": "বৃহস্পতিবার",
      "my": "ကြာသပတေး",
      "cs": "Čtvrtek",
      "fa-AF": "پنج‌شنبه",
      "fa-FA": "پنج‌شنبه",
      "de-DE": "Donnerstag",
      "el": "Πέμπτη",
      "ha-HA": "Alhamis",
      "hu-HU": "Csütörtök",
      "it-IT": "Giovedì",
      "KAU": "Alhamis",
      "ki-KI": "Kiumia wa Keri",
      "ln-LN": "Jeudi",
      "ps-PS": "پنج‌شنبه",
      "ru-RU": "Четверг",
      "sw-SW": "Alhamisi",
      "th": "วันพฤหัสบดี",
      "uk-UK": "Четвер"
    },
Friday: {
      "en-US": "Friday",
      am: "አርብ",
      "ar-SA": "الجمعة",
      "fr-FR": "Vendredi",
      "es-ES": "Viernes",
      "so-SO": "Jimco",
      "ur-UR": "جمعہ",
      "ht": "Vandredi",
      "fr-HT": "Vandredi",
      "bn": "শুক্রবার",
      "my": "သောကြာ",
      "cs": "Pátek",
      "fa-AF": "جمعه",
      "fa-FA": "جمعه",
      "de-DE": "Freitag",
      "el": "Παρασκευή",
      "ha-HA": "Jumma’a",
      "hu-HU": "Péntek",
      "it-IT": "Venerdì",
      "KAU": "Jumma’a",
      "ki-KI": "Njumaa",
      "ln-LN": "Vendredi",
      "ps-PS": "جمعه",
      "ru-RU": "Пятница",
      "sw-SW": "Ijumaa",
      "th": "วันศุกร์",
      "uk-UK": "П’ятниця"
    },
Saturday: {
      "en-US": "Saturday",
      am: "ቅዳሜ",
      "ar-SA": "السبت",
      "fr-FR": "Samedi",
      "es-ES": "Sábado",
      "so-SO": "Sabti",
      "ur-UR": "ہفتہ",
      "ht": "Samdi",
      "fr-HT": "Samdi",
      "bn": "শনিবার",
      "my": "စနေနေ့",
      "cs": "Sobota",
      "fa-AF": "شنبه",
      "fa-FA": "شنبه",
      "de-DE": "Samstag",
      "el": "Σάββατο",
      "ha-HA": "Asabar",
      "hu-HU": "Szombat",
      "it-IT": "Sabato",
      "KAU": "Asabar",
      "ki-KI": "Njumamothi",
      "ln-LN": "Samedi",
      "ps-PS": "شنبه",
      "ru-RU": "Суббота",
      "sw-SW": "Jumamosi",
      "th": "วันเสาร์",
      "uk-UK": "Субота"
    },
links: {
      "en-US": "Links",
      am: "አገናኞች",
      "ar-SA": "روابط",
      "fr-FR": "Liens",
      "es-ES": "Enlaces",
      "so-SO": "Xiriirro",
      "ur-UR": "روابط",
      "ht": "Lyen",
      "fr-HT": "Lyen",
      "bn": "লিঙ্কসমূহ",
      "my": "လင့်ခ်များ",
      "cs": "Odkazy",
      "fa-AF": "پیوندها",
      "fa-FA": "پیوندها",
      "de-DE": "Links",
      "el": "Σύνδεσμοι",
      "ha-HA": "Hanyoyin haɗi",
      "hu-HU": "Hivatkozások",
      "it-IT": "Link",
      "KAU": "Hanyoyin haɗi",
      "ki-KI": "Maungo",
      "ln-LN": "Ba lien",
      "ps-PS": "لینکونه",
      "ru-RU": "Ссылки",
      "sw-SW": "Viungo",
      "th": "ลิงก์",
      "uk-UK": "Посилання:"
    },
categories: {
      "en-US": "Categories",
      am: "ምድቦች",
      "ar-SA": "الفئات",
      "fr-FR": "Catégories",
      "es-ES": "Categorías",
      "so-SO": "Qaybaha",
      "ur-UR": "زمرہ جات",
      "ht": "Kategori",
      "fr-HT": "Kategori",
      "bn": "বিভাগসমূহ",
      "my": "အမျိုးအစားများ",
      "cs": "Kategorie",
      "fa-AF": "دسته‌بندی‌ها",
      "fa-FA": "دسته‌بندی‌ها",
      "de-DE": "Kategorien",
      "el": "Κατηγορίες",
      "ha-HA": "Rukuni",
      "hu-HU": "Kategóriák",
      "it-IT": "Categorie",
      "KAU": "Rukuni",
      "ki-KI": "Mabango",
      "ln-LN": "Bikategori",
      "ps-PS": "کټګورۍ",
      "ru-RU": "Категории",
      "sw-SW": "Kategoria",
      "th": "หมวดหมู่",
      "uk-UK": "Категорії"
    },
    serviceCategories: {
      "en-US": "Service Categories",
      am: "የአገልግሎት ምድቦች",
      "ar-SA": "فئات الخدمة",
      "fr-FR": "Catégories de services",
      "es-ES": "Categorías de servicios",
      "so-SO": "Qaybaha adeegga",
      "ur-UR": "سروس کی زمرہ جات",
      "ht": "Kategori sèvis",
      "fr-HT": "Kategori sèvis",
      "bn": "সেবার বিভাগসমূহ",
      "my": "ဝန်ဆှုအမျိုးအစားများ",
      "cs": "Kategorie služeb",
      "fa-AF": "دسته‌بندی‌های خدمات",
      "fa-FA": "دسته‌بندی‌های خدمات",
      "de-DE": "Dienstkategorien",
      "el": "Κατηγορίες υπηρεσιών",
      "ha-HA": "Rukunin sabis",
      "hu-HU": "Szolgáltatási kategóriák",
      "it-IT": "Categorie di servizio",
      "KAU": "Rukunin sabis",
      "ki-KI": "Mabango ya huduma",
      "ln-LN": "Bikategori ya mosala",
      "ps-PS": "د خدمت کټګورۍ",
      "ru-RU": "Категории услуг",
      "sw-SW": "Kategoria za huduma",
      "th": "หมวดหมู่บริการ",
      "uk-UK": "Категорії послуг",
    },
resources: {
      "en-US": "Resources",
      am: "መረጃዎች",
      "ar-SA": "الموارد",
      "fr-FR": "Ressources",
      "es-ES": "Recursos",
      "so-SO": "Khayraad",
      "ur-UR": "وسائل",
      "ht": "Resous",
      "fr-HT": "Ressources",
      "bn": "সম্পদ",
      "my": "အရင်းအမြစ်များ",
      "cs": "Zdroje",
      "fa-AF": "منابع",
      "fa-FA": "منابع",
      "de-DE": "Ressourcen",
      "el": "Πόροι",
      "ha-HA": "Albarkatu",
      "hu-HU": "Erőforrás",
      "it-IT": "Risorse",
      "KAU": "Razəgə",
      "ki-KI": "Ubutunzi",
      "ln-LN": "Biloko",
      "ps-PS": "سرچینې",
      "ru-RU": "Ресурсы",
      "sw-SW": "Rasilimali",
      "th": "ทรัพยากร",
      "uk-UK": "Матеріали:"
    },
    askAI: {
        "en-US": "Ask AI",
        am: "AIን ጠይቅ",
        "ar-SA": "اسأل الذكاء الاصطناعي",
        "fr-FR": "Demander à l'IA",
        "es-ES": "Preguntar a la IA",
        "so-SO": "Weydii AI",
        "ur-UR": "AI سے پوچھیں",
        "ht": "Mande AI",
        "fr-HT": "Mande AI",
        "bn": "এআইকে জিজ্ঞাসা করুন",
        "my": "AI ကိုမေးပါ",
        "cs": "Zeptat se AI",
        "fa-AF": "از AI بپرسید",
        "fa-FA": "از AI بپرسید",
        "de-DE": "Frag die KI",
        "el": "Ρώτησε την AI",
        "ha-HA": "Tambayi AI",
        "hu-HU": "Kérdezd az AI-t",
        "it-IT": "Chiedi all'IA",
        "KAU": "Tambayi AI",
        "ki-KI": "Uliza AI",
        "ln-LN": "Demander à l'IA",
        "ps-PS": "له AI څخه پوښتنه وکړئ",
        "ru-RU": "Спросите ИИ",
        "sw-SW": "Uliza AI",
        "th": "ถาม AI",
        "uk-UK": "Запитати ШІ"
    },
    clearAIFilters: {
        "en-US": "Clear map filters",
        am: "የካርታ ማጣሪያዎችን አጽዳ",
        "ar-SA": "مسح مرشحات الخريطة",
        "fr-FR": "Effacer les filtres de la carte",
        "es-ES": "Borrar filtros del mapa",
        "so-SO": "Nadiifi shaandhada khariidad",
        "ur-UR": "نقشے کے فلٹرز صاف کریں",
        "ht": "Efase filtè kat la",
        "fr-HT": "Efase filtè kat la",
        "bn": "মানচিত্রের ফিল্টার মুছুন",
        "my": "မြေပုံ filter များကို ရှင်းပါ",
        "cs": "Vymazat filtry mapy",
        "fa-AF": "پاک کردن فیلترهای نقشه",
        "fa-FA": "پاک کردن فیلترهای نقشه",
        "de-DE": "Kartenfilter löschen",
        "el": "Καθαρισμός φίλτρων χάρτη",
        "ha-HA": "Share tace-tacen taswira",
        "hu-HU": "Térképszűrők törlése",
        "it-IT": "Cancella filtri mappa",
        "KAU": "Share tace-tacen taswira",
        "ki-KI": "Futa vichujio vya ramani",
        "ln-LN": "Effacer les filtres de la carte",
        "ps-PS": "د نقشې فیلترونه پاک کړئ",
        "ru-RU": "Сбросить фильтры карты",
        "sw-SW": "Futa vichujio vya ramani",
        "th": "ล้างตัวกรองแผนที่",
        "uk-UK": "Скинути фільтри карти"
    },
    aiAskTitle: {
        "en-US": "Service Scout",
        am: "Service Scout",
        "ar-SA": "خدمة الكشافة",
        "fr-FR": "Service Scout",
        "es-ES": "Service Scout",
        "so-SO": "Service Scout",
        "ur-UR": "سروس اسکاوٹ",
        "ht": "Service Scout",
        "fr-HT": "Service Scout",
        "bn": "Service Scout",
        "my": "Service Scout",
        "cs": "Service Scout",
        "fa-AF": "Service Scout",
        "fa-FA": "Service Scout",
        "de-DE": "Service Scout",
        "el": "Service Scout",
        "ha-HA": "Service Scout",
        "hu-HU": "Service Scout",
        "it-IT": "Service Scout",
        "KAU": "Service Scout",
        "ki-KI": "Service Scout",
        "ln-LN": "Service Scout",
        "ps-PS": "Service Scout",
        "ru-RU": "Service Scout",
        "sw-SW": "Service Scout",
        "th": "Service Scout",
        "uk-UK": "Service Scout"
    },
    aiExampleFood: {
        "en-US": "Ask about food support",
        am: "ስለ የምግብ ድጋፍ ጠይቅ",
        "ar-SA": "اسأل عن دعم الغذاء",
        "fr-FR": "Demander un soutien alimentaire",
        "es-ES": "Preguntar sobre el apoyo alimentario",
        "so-SO": "Weydiiso taageerada cuntada",
        "ur-UR": "کھانے کی مدد کے بارے میں پوچھیں",
        "ht": "Mande sou sipò alimantè",
        "fr-HT": "Mande sou sipò alimantè",
        "bn": "খাবার সহায়তা সম্পর্কে জিজ্ঞাসা করুন",
        "my": "အစားအသောက်ထောက်ပံ့မှုကိုမေးပါ",
        "cs": "Zeptat se na podporu potravin",
        "fa-AF": "از حمایت غذایی بپرسید",
        "fa-FA": "از حمایت غذایی بپرسید",
        "de-DE": "Frag nach Lebensmittelhilfe",
        "el": "Ρώτησε για στήριξη τροφίμων",
        "ha-HA": "Tambayi tallafin abinci",
        "hu-HU": "Kérdezd az élelmiszer-támogatást",
        "it-IT": "Chiedi informazioni sul supporto alimentare",
        "KAU": "Tambayi tallafin abinci",
        "ki-KI": "Uliza msaada wa chakula",
        "ln-LN": "Demander un soutien alimentaire",
        "ps-PS": "له خواړو ملاتړ څخه پوښتنه وکړئ",
        "ru-RU": "Спросите о продовольственной помощи",
        "sw-SW": "Uliza msaada wa chakula",
        "th": "ถามเกี่ยวกับการสนับสนุนอาหาร",
        "uk-UK": "Запитати про продовольчу допомогу"
    },
    aiAskSubtitle: {
        "en-US": "Ask anything:",
        am: "ማንኛውንም ነገር ጠይቅ፦",
        "ar-SA": "اسأل أي شيء:",
        "fr-FR": "Demander n'importe quoi:",
        "es-ES": "Preguntar cualquier cosa:",
        "so-SO": "Weydiiso wax kasta:",
        "ur-UR": "کچھ بھی پوچھیں:",
        "ht": "Mande nenpòt bagay:",
        "fr-HT": "Mande nenpòt bagay:",
        "bn": "যা কিছু জিজ্ঞাসা করুন:",
        "my": "ဘာမဆိုမေးပါ:",
        "cs": "Zeptejte se na cokoliv:",
        "fa-AF": "هر چیزی بپرسید:",
        "fa-FA": "هر چیزی بپرسید:",
        "de-DE": "Frag irgendetwas:",
        "el": "Ρώτησε οτιδήποτε:",
        "ha-HA": "Tambayi komai:",
        "hu-HU": "Kérdezz bármit:",
        "it-IT": "Chiedi qualsiasi cosa:",
        "KAU": "Tambayi komai:",
        "ki-KI": "Uliza chochote:",
        "ln-LN": "Demander n'importe quoi:",
        "ps-PS": "له هرڅه څخه پوښتنه وکړئ:",
        "ru-RU": "Спросите что угодно:",
        "sw-SW": "Uliza chochote:",
        "th": "ถามอะไรก็ได้:",
        "uk-UK": "Запитати будь-що:"
    },
    aiExampleMentalHealth: {
        "en-US": "Ask about mental health resources",
        am: "ስለ የአእምሮ ጤና መረጃዎች ጠይቅ",
        "ar-SA": "اسأل عن موارد الصحة النفسية",
        "fr-FR": "Demander des ressources en santé mentale",
        "es-ES": "Preguntar sobre recursos de salud mental",
        "so-SO": "Weydiiso ilaha caafimaadka dhimirka",
        "ur-UR": "ذہنی صحت کے وسائل کے بارے میں پوچھیں",
        "ht": "Mande sou resous sante mantal",
        "fr-HT": "Mande sou resous sante mantal",
        "bn": "মানসিক স্বাস্থ্য সংক্রান্ত সম্পদ সম্পর্কে জিজ্ঞাসা করুন",
        "my": "စိတ်ကျန်းမာရေးအရင်းအမြစ်များကိုမေးပါ",
        "cs": "Zeptat se na zdroje duševního zdraví",
        "fa-AF": "از منابع صحت روانی بپرسید",
        "fa-FA": "از منابع سلامت روان بپرسید",
        "de-DE": "Frag nach Ressourcen für psychische Gesundheit",
        "el": "Ρώτησε για πόρους ψυχικής υγείας",
        "ha-HA": "Tambayi albarkatun lafiyar hankali",
        "hu-HU": "Kérdezd a mentális egészség erőforrásait",
        "it-IT": "Chiedi informazioni sulle risorse per la salute mentale",
        "KAU": "Tambayi albarkatun lafiyar hankali",
        "ki-KI": "Uliza rasilimali za afya ya akili",
        "ln-LN": "Demander des ressources en santé mentale",
        "ps-PS": "له رواني صحت ملاتړ څخه پوښتنه وکړئ",
        "ru-RU": "Спросите о ресурсах психического здоровья",
        "sw-SW": "Uliza rasilimali za afya ya akili",
        "th": "ถามเกี่ยวกับทรัพยากรสุขภาพจิต:",
        "uk-UK": "Запитати про ресурси психічного здоров'я:"
    },
    aiExampleNewcomers: {
        "en-US": "Ask about resources for newcomers",
        am: "ስለ አዲስ መጤዎች መረጃዎች ጠይቅ",
        "ar-SA": "اسأل عن موارد للمبتدئين",
        "fr-FR": "Demander des ressources pour les nouveaux arrivants",
        "es-ES": "Preguntar sobre recursos para recién llegados",
        "so-SO": "Weydiiso ilaha cusub",
        "ur-UR": "نئے آنے والوں کے وسائل کے بارے میں پوچھیں",
        "ht": "Mande sou resous pou nouvo vini",
        "fr-HT": "Mande sou resous pou nouvo vini",
        "bn": "নতুন আগতদের জন্য সম্পদ সম্পর্কে জিজ্ঞাসা করুন",
        "my": "အသစ်ရောက်ရှိသူများအတွက်အရင်းအမြစ်များကိုမေးပါ",
        "cs": "Zeptat se na zdroje pro nově příchozí",
        "fa-AF": "از منابع برای تازه واردان بپرسید",
        "fa-FA": "از منابع برای تازه واردان بپرسید",
        "de-DE": "Frag nach Ressourcen für Neuankömmlinge",
        "el": "Ρώτησε για πόρους για νέους μετανάστες",
        "ha-HA": "Tambayi albarkatun sabbin shiga",
        "hu-HU": "Kérdezd az újonnan érkezők erőforrásait",
        "it-IT": "Chiedi informazioni sulle risorse per i nuovi arrivati",
        "KAU": "Tambayi albarkatun sabbin shiga",
        "ki-KI": "Uliza rasilimali za wahamiaji wapya",
        "ln-LN": "Demander des ressources pour les nouveaux arrivants",
        "ps-PS": "له نوي راتلونکو لپاره ملاتړ څخه پوښتنه وکړئ",
        "ru-RU": "Спросите о ресурсах для новых иммигрантов",
        "sw-SW": "Uliza rasilimali za wahamiaji wapya",
        "th": "ถามเกี่ยวกับทรัพยากรสำหรับผู้มาใหม่:",
        "uk-UK": "Запитати про ресурси для новоприбулих:"
    },
    aiPlaceholder: {
        "en-US": "How can I help you?",
        am: "እንዴት ልረዳዎ?",
        "ar-SA": "اكتب هنا",
        "fr-FR": "Tapez ici",
        "es-ES": "Escribe aquí",
        "so-SO": "Halkan ku qor",
        "ur-UR": "یہاں ٹائپ کریں",
        "ht": "Tape isit la",
        "fr-HT": "Tape isit la",
        "bn": "এখানে টাইপ করুন",
        "my": "ဤနေရာတွင်ရိုက်ပါ",
        "cs": "Napište sem",
        "fa-AF": "اینجا بنویسید",
        "fa-FA": "اینجا بنویسید",
        "de-DE": "Hier tippen",
        "el": "Πληκτρολογήστε εδώ",
        "ha-HA": "Rubuta anan",
        "hu-HU": "Írja ide",
        "it-IT": "Scrivi qui",
        "KAU": "Rubuta anan",
        "ki-KI": "Andika hapa",
        "ln-LN": "Tapez ici",
        "ps-PS": "دلته ولیکئ",
        "ru-RU": "Введите здесь",
        "sw-SW": "Andika hapa",
        "th": "พิมพ์ที่นี่",
        "uk-UK": "Наберіть тут:"
    },
    aiDisclaimerShort: {
        "en-US": "Ask AI can make mistakes. Please confirm details with the service directly.",
        "am": "AI ጠይቅ ስህተት ሊሠራ ይችላል። እባክዎ ዝርዝሮችን አገልግሎቱን በቀጥታ በማነጋገር ያረጋግጡ።",
        "ar-SA": "قد يخطئ «اسأل الذكاء الاصطناعي». يُرجى التأكد من التفاصيل مع الخدمة مباشرةً.",
        "fr-FR": "« Demander à l'IA » peut se tromper. Veuillez confirmer les détails directement auprès du service.",
        "es-ES": "Preguntar a la IA puede cometer errores. Confirme los detalles directamente con el servicio.",
        "so-SO": "Weydii AI waa inuu qaldamo. Fadlan si toos ah ula xaqiiji faahfaahinta adeegga.",
        "ur-UR": "AI سے پوچھیں سے غلطیاں ہو سکتی ہیں۔ براہِ کرم تفصیلات کی تصدیق براہِ راست خدمت سے کریں۔",
        "ht": "Mande AI ka fè erè. Tanpri konfime detay yo dirèkteman ak sèvis la.",
        "bn": "এআইকে জিজ্ঞাসা করুন ভুল করতে পারে। অনুগ্রহ করে বিস্তারিত সরাসরি পরিষেবাটির কাছ থেকে নিশ্চিত করুন।",
        "my": "AI ကို မေးပါ တွင် အမှားများ ရှိနိုင်သည်။ အသေးစိတ်ကို ဝန်ဆောင်မှုနှင့် တိုက်ရိုက်အတည်ပြုပါ။",
        "cs": "Funkce Zeptat se AI může dělat chyby. Podrobnosti si prosím ověřte přímo u dané služby.",
        "fa-AF": "«پرسش از هوش مصنوعی» ممکن است اشتباه کند. لطفاً جزئیات را مستقیماً با آن خدمت تأیید کنید.",
        "de-DE": "„KI fragen“ kann Fehler machen. Bitte bestätigen Sie Details direkt beim Angebot.",
        "el": "Το «Ρωτήστε την ΤΝ» μπορεί να κάνει λάθη. Επιβεβαιώστε τις λεπτομέρειες απευθείας με την υπηρεσία.",
        "ha-HA": "Tambayi AI na iya yin kuskure. Da fatan za ku tabbatar da cikakkun bayanai kai tsaye da ma'aikatar.",
        "hu-HU": "A Kérdezd az MI-t tévedhet. Kérjük, a részleteket közvetlenül a szolgáltatónál ellenőrizze.",
        "it-IT": "Chiedi all'IA può commettere errori. Conferma i dettagli direttamente con il servizio.",
        "ln-LN": "Senga AI ekoki kosala mabunga. Svp ndimisa makambo na ndenge ya pwasa na mosala yango.",
        "ps-PS": "د AI پوښتنه ښايي تېروتنه وکړي. مهرباني وکړئ توضیحات مستقیماً له خدمت سره تایید کړئ.",
        "ru-RU": "«Спросить ИИ» может ошибаться. Пожалуйста, уточняйте детали непосредственно в организации.",
        "sw-SW": "Uliza AI inaweza kukosea. Tafadhali thibitisha maelezo moja kwa moja na huduma husika.",
        "th": "ถาม AI อาจผิดพลาดได้ โปรดยืนยันรายละเอียดกับบริการโดยตรง",
        "uk-UK": "«Запитати ШІ» може помилятися. Будь ласка, уточнюйте деталі безпосередньо в організації.",
        "vi-VN": "Hỏi AI có thể mắc lỗi. Vui lòng xác nhận chi tiết trực tiếp với dịch vụ.",
        "ko-KR": "AI에게 질문하기는 오류를 낼 수 있습니다. 세부 정보는 해당 서비스에 직접 확인하세요.",
        "zh-CN": "“询问 AI”可能出错。请直接向相关服务机构确认详情。",
        "fr-HT": "« Demander à l'IA » peut se tromper. Veuillez confirmer les détails directement auprès du service.",
        "fa-FA": "«پرسش از هوش مصنوعی» ممکن است اشتباه کند. لطفاً جزئیات را مستقیماً با آن خدمت تأیید کنید."
    },
    aiDisclaimerLabel: {
        "en-US": "Terms & privacy",
        "am": "ውሎች እና ግላዊነት",
        "ar-SA": "الشروط والخصوصية",
        "fr-FR": "Conditions et confidentialité",
        "es-ES": "Términos y privacidad",
        "so-SO": "Shuruudaha iyo asturnaanta",
        "ur-UR": "شرائط اور رازداری",
        "ht": "Tèm ak konfidansyalite",
        "bn": "শর্তাবলি ও গোপনীয়তা",
        "my": "စည်းမျဉ်းများနှင့် ကိုယ်ရေးလုံခြုံမှု",
        "cs": "Podmínky a soukromí",
        "fa-AF": "شرایط و حریم خصوصی",
        "de-DE": "Bedingungen & Datenschutz",
        "el": "Όροι και απόρρητο",
        "ha-HA": "Sharuɗɗa da sirri",
        "hu-HU": "Feltételek és adatvédelem",
        "it-IT": "Termini e privacy",
        "ln-LN": "Mibeko mpe bobateli ya makambo ya moto",
        "ps-PS": "شرطونه او محرمیت",
        "ru-RU": "Условия и конфиденциальность",
        "sw-SW": "Masharti na faragha",
        "th": "ข้อกำหนดและความเป็นส่วนตัว",
        "uk-UK": "Умови та конфіденційність",
        "vi-VN": "Điều khoản & quyền riêng tư",
        "ko-KR": "약관 및 개인정보",
        "zh-CN": "条款与隐私",
        "fr-HT": "Conditions et confidentialité",
        "fa-FA": "شرایط و حریم خصوصی"
    },
    aiDisclaimerUse: {
        "en-US": "The Ask AI feature on the Switchboard Resource Map uses artificial intelligence to answer questions and suggest services from the map. It is not a lawyer, caseworker, or other professional, and it does not make decisions about your eligibility for any service or benefit. Answers may be incomplete, or out-of-date, so please contact the service directly to confirm hours, location, and requirements. Please do not include personal or sensitive information in your questions.",
        "am": "በSwitchboard የሃብት ካርታ ላይ ያለው «AI ጠይቅ» ባህሪ ጥያቄዎችን ለመመለስና ከካርታው አገልግሎቶችን ለመጠቆም ሰው ሰራሽ አስተውሎትን (AI) ይጠቀማል። ጠበቃ፣ ጉዳይ አስፈጻሚ ወይም ሌላ ባለሙያ አይደለም፤ ለማንኛውም አገልግሎት ወይም ጥቅም ብቁ መሆንዎን በተመለከተም ውሳኔ አይሰጥም። መልሶች ያልተሟሉ ወይም ጊዜ ያለፈባቸው ሊሆኑ ይችላሉ፤ ስለዚህ የሥራ ሰዓቱን፣ ቦታውንና መስፈርቶቹን ለማረጋገጥ አገልግሎቱን በቀጥታ ያነጋግሩ። እባክዎ በጥያቄዎችዎ ውስጥ የግል ወይም ሚስጥራዊ መረጃ አያካትቱ።",
        "ar-SA": "تستخدم ميزة «اسأل الذكاء الاصطناعي» في خريطة موارد Switchboard الذكاء الاصطناعي للإجابة عن الأسئلة واقتراح خدمات من الخريطة. وهي ليست محاميًا ولا مديرًا للحالات ولا أي مختص آخر، ولا تتخذ قرارات بشأن أهليتك لأي خدمة أو منفعة. قد تكون الإجابات ناقصة أو قديمة، لذا يُرجى التواصل مع الخدمة مباشرةً للتأكد من ساعات العمل والموقع والشروط. يُرجى عدم تضمين معلومات شخصية أو حساسة في أسئلتك.",
        "fr-FR": "La fonction « Demander à l'IA » de la carte des ressources Switchboard utilise l'intelligence artificielle pour répondre à vos questions et suggérer des services à partir de la carte. Elle n'est ni un avocat, ni un travailleur social, ni un autre professionnel, et elle ne prend aucune décision concernant votre admissibilité à un service ou à une prestation. Les réponses peuvent être incomplètes ou obsolètes ; veuillez donc contacter directement le service pour confirmer les horaires, l'adresse et les conditions. Veuillez ne pas inclure d'informations personnelles ou sensibles dans vos questions.",
        "es-ES": "La función «Preguntar a la IA» del Mapa de recursos de Switchboard utiliza inteligencia artificial para responder preguntas y sugerir servicios del mapa. No es un abogado, un trabajador de casos ni otro profesional, y no toma decisiones sobre su elegibilidad para ningún servicio o beneficio. Las respuestas pueden estar incompletas o desactualizadas, por lo que le recomendamos contactar directamente con el servicio para confirmar el horario, la ubicación y los requisitos. Le pedimos que no incluya información personal ni confidencial en sus preguntas.",
        "so-SO": "Qaybta «Weydii AI» ee Khariidadda Khayraadka Switchboard waxay isticmaashaa sirdoonka macmalka ah (AI) si ay uga jawaabto su'aalaha una soo jeediso adeegyo ka mid ah khariidadda. Ma aha qareen, shaqaale kiis, ama xirfadle kale, mana gaarto go'aamo ku saabsan in aad xaq u leedahay adeeg ama gunno kasta. Jawaabuhu way noqon karaan kuwo aan dhammaystirnayn ama duugoobay, sidaa darteed fadlan si toos ah ula xiriir adeegga si aad u xaqiijiso saacadaha, goobta iyo shuruudaha. Fadlan ha ku darin macluumaad shakhsi ah ama xasaasi ah su'aalahaaga.",
        "ur-UR": "Switchboard ریسورس میپ پر «AI سے پوچھیں» کی خصوصیت سوالات کے جواب دینے اور میپ سے خدمات تجویز کرنے کے لیے مصنوعی ذہانت استعمال کرتی ہے۔ یہ کوئی وکیل، کیس ورکر یا دیگر پیشہ ور نہیں ہے، اور یہ کسی خدمت یا فائدے کے لیے آپ کی اہلیت کے بارے میں فیصلے نہیں کرتی۔ جوابات نامکمل یا پرانے ہو سکتے ہیں، اس لیے اوقات، مقام اور شرائط کی تصدیق کے لیے براہِ کرم براہِ راست خدمت سے رابطہ کریں۔ براہِ کرم اپنے سوالات میں ذاتی یا حساس معلومات شامل نہ کریں۔",
        "ht": "Fonksyon «Mande AI» sou Kat Resous Switchboard la sèvi ak entèlijans atifisyèl pou reponn kesyon epi sijere sèvis ki sou kat la. Li pa yon avoka, yon travayè sosyal oswa yon lòt pwofesyonèl, e li pa pran okenn desizyon sou si ou kalifye pou yon sèvis oswa yon avantaj. Repons yo ka enkonplè oswa pa ajou, kidonk tanpri kontakte sèvis la dirèkteman pou konfime è, adrès ak kondisyon yo. Tanpri pa mete enfòmasyon pèsonèl oswa sansib nan kesyon ou yo.",
        "bn": "Switchboard রিসোর্স ম্যাপের «এআইকে জিজ্ঞাসা করুন» সুবিধাটি প্রশ্নের উত্তর দিতে এবং ম্যাপ থেকে পরিষেবা প্রস্তাব করতে কৃত্রিম বুদ্ধিমত্তা ব্যবহার করে। এটি কোনো আইনজীবী, কেসওয়ার্কার বা অন্য কোনো পেশাজীবী নয়, এবং কোনো পরিষেবা বা সুবিধার জন্য আপনার যোগ্যতা সম্পর্কে এটি সিদ্ধান্ত নেয় না। উত্তরগুলো অসম্পূর্ণ বা পুরোনো হতে পারে, তাই সময়, অবস্থান ও প্রয়োজনীয় শর্ত নিশ্চিত করতে অনুগ্রহ করে সরাসরি পরিষেবাটির সাথে যোগাযোগ করুন। অনুগ্রহ করে আপনার প্রশ্নে ব্যক্তিগত বা সংবেদনশীল তথ্য দেবেন না।",
        "my": "Switchboard အရင်းအမြစ်မြေပုံပေါ်ရှိ «AI ကို မေးပါ» လုပ်ဆောင်ချက်သည် မေးခွန်းများကို ဖြေဆိုရန်နှင့် မြေပုံပေါ်မှ ဝန်ဆောင်မှုများကို အကြံပြုရန် ဉာဏ်ရည်တု (AI) ကို အသုံးပြုသည်။ ၎င်းသည် ရှေ့နေ၊ ကိစ္စရပ်ကိုင်တွယ်သူ သို့မဟုတ် အခြားပညာရှင် မဟုတ်ပါ၊ မည်သည့်ဝန်ဆောင်မှု သို့မဟုတ် အကျိုးခံစားခွင့်အတွက်မဆို သင့်အရည်အချင်းပြည့်မီမှုကို ဆုံးဖြတ်ခြင်းလည်း မပြုလုပ်ပါ။ အဖြေများသည် မပြည့်စုံခြင်း သို့မဟုတ် ခေတ်နောက်ကျနေခြင်း ဖြစ်နိုင်သဖြင့် ဖွင့်ချိန်၊ တည်နေရာနှင့် လိုအပ်ချက်များကို အတည်ပြုရန် ဝန်ဆောင်မှုနှင့် တိုက်ရိုက်ဆက်သွယ်ပါ။ သင့်မေးခွန်းများတွင် ကိုယ်ရေးကိုယ်တာ သို့မဟုတ် အရေးကြီးသော အချက်အလက်များ မထည့်ပါနှင့်။",
        "cs": "Funkce Zeptat se AI na mapě zdrojů Switchboard využívá umělou inteligenci k odpovídání na otázky a doporučování služeb z mapy. Není to právník, sociální pracovník ani jiný odborník a nerozhoduje o tom, zda máte nárok na nějakou službu nebo dávku. Odpovědi mohou být neúplné nebo zastaralé, proto se prosím obraťte přímo na danou službu a ověřte si otevírací dobu, umístění a požadavky. Do svých dotazů prosím nezadávejte osobní ani citlivé údaje.",
        "fa-AF": "قابلیت «پرسش از هوش مصنوعی» در نقشه منابع Switchboard از هوش مصنوعی برای پاسخ به پرسش‌ها و پیشنهاد خدمات از روی نقشه استفاده می‌کند. این قابلیت وکیل، کارمند پرونده یا متخصص دیگری نیست و درباره واجد شرایط بودن شما برای هیچ خدمت یا مزیتی تصمیم نمی‌گیرد. پاسخ‌ها ممکن است ناقص یا قدیمی باشند، بنابراین لطفاً برای تأیید ساعات کاری، موقعیت و شرایط، مستقیماً با آن خدمت تماس بگیرید. لطفاً در پرسش‌های خود اطلاعات شخصی یا حساس وارد نکنید.",
        "de-DE": "Die Funktion „KI fragen“ auf der Switchboard-Ressourcenkarte nutzt künstliche Intelligenz, um Fragen zu beantworten und Angebote aus der Karte vorzuschlagen. Sie ist weder Rechtsanwalt noch Sozialarbeiter oder sonstige Fachkraft und trifft keine Entscheidungen darüber, ob Sie Anspruch auf eine Leistung oder ein Angebot haben. Antworten können unvollständig oder veraltet sein. Bitte wenden Sie sich daher direkt an das Angebot, um Öffnungszeiten, Standort und Voraussetzungen zu bestätigen. Bitte geben Sie in Ihren Fragen keine persönlichen oder sensiblen Informationen an.",
        "el": "Η λειτουργία «Ρωτήστε την ΤΝ» στον Χάρτη Πόρων του Switchboard χρησιμοποιεί τεχνητή νοημοσύνη για να απαντά σε ερωτήσεις και να προτείνει υπηρεσίες από τον χάρτη. Δεν είναι δικηγόρος, κοινωνικός λειτουργός ή άλλος επαγγελματίας και δεν λαμβάνει αποφάσεις σχετικά με το αν δικαιούστε κάποια υπηρεσία ή παροχή. Οι απαντήσεις μπορεί να είναι ελλιπείς ή παρωχημένες, γι' αυτό επικοινωνήστε απευθείας με την υπηρεσία για να επιβεβαιώσετε ώρες, τοποθεσία και προϋποθέσεις. Παρακαλούμε μην συμπεριλαμβάνετε προσωπικές ή ευαίσθητες πληροφορίες στις ερωτήσεις σας.",
        "ha-HA": "Fasalin «Tambayi AI» a taswirar albarkatu ta Switchboard yana amfani da fasahar kwakwalwar na'ura (AI) don amsa tambayoyi da kuma ba da shawarar ayyuka daga taswirar. Ba lauya ba ne, ba ma'aikacin shari'a ba ne, kuma ba wani ƙwararre ba ne, kuma ba ya yanke hukunci kan ko kun cancanci wani aiki ko amfani. Amsoshi na iya zama marasa cika ko tsofaffi, don haka da fatan za ku tuntuɓi ma'aikatar kai tsaye don tabbatar da lokutan aiki, wuri, da buƙatu. Da fatan kada ku saka bayanan sirri ko masu muhimmanci a tambayoyinku.",
        "hu-HU": "A Switchboard erőforrástérkép „Kérdezd az MI-t” funkciója mesterséges intelligenciát használ a kérdések megválaszolására és a térképen szereplő szolgáltatások javaslatára. Nem ügyvéd, szociális munkás vagy más szakember, és nem dönt arról, hogy jogosult-e valamely szolgáltatásra vagy juttatásra. A válaszok hiányosak vagy elavultak lehetnek, ezért kérjük, közvetlenül a szolgáltatónál ellenőrizze a nyitvatartást, a helyszínt és a feltételeket. Kérjük, ne adjon meg személyes vagy érzékeny adatokat a kérdéseiben.",
        "it-IT": "La funzione «Chiedi all'IA» della mappa delle risorse di Switchboard utilizza l'intelligenza artificiale per rispondere alle domande e suggerire servizi dalla mappa. Non è un avvocato, un assistente sociale o un altro professionista e non prende decisioni sulla tua idoneità a un servizio o a un beneficio. Le risposte possono essere incomplete o non aggiornate, quindi contatta direttamente il servizio per confermare orari, sede e requisiti. Ti preghiamo di non inserire informazioni personali o sensibili nelle tue domande.",
        "ln-LN": "Fonctionnalité «Senga AI» na mapi ya bisombeli ya Switchboard esalelaka bwanya ya makambo ya masini (AI) mpo na koyanola mituna mpe kopesa makanisi ya misala oyo ezali na mapi. Ezali avoka te, mosali ya makambo te to moto mosusu ya mayele te, mpe ekokataka likambo te soki ozali na ndingisa ya kozwa mosala to litomba moko. Biyano ekoki kozala mobimba te to ya kala, yango wana svp benga mosala yango na ndenge ya pwasa mpo na kondimisa ngonga, esika mpe masengami. Svp tya ata ba informations ya moto ya yo moko to oyo ezali na likama te na mituna na yo.",
        "ps-PS": "د Switchboard د سرچینو نقشې «د AI پوښتنه» ځانګړنه د پوښتنو ځواب ورکولو او له نقشې څخه د خدماتو وړاندیز کولو لپاره مصنوعي ځیرکتیا کاروي. دا نه وکیل دی، نه د قضیې کارکوونکی او نه بل مسلکي کس، او د کوم خدمت یا ګټې لپاره ستاسو د وړتیا په اړه پریکړې نه کوي. ځوابونه ښايي نیمګړي یا زاړه وي، نو مهرباني وکړئ د وختونو، موقعیت او اړتیاوو د تایید لپاره مستقیماً له خدمت سره اړیکه ونیسئ. مهرباني وکړئ په خپلو پوښتنو کې شخصي یا حساسې معلومات مه شاملوئ.",
        "ru-RU": "Функция «Спросить ИИ» на карте ресурсов Switchboard использует искусственный интеллект, чтобы отвечать на вопросы и предлагать услуги с карты. Он не является юристом, социальным работником или другим специалистом и не принимает решений о том, имеете ли вы право на какую-либо услугу или пособие. Ответы могут быть неполными или устаревшими, поэтому, пожалуйста, свяжитесь с организацией напрямую, чтобы уточнить часы работы, адрес и требования. Пожалуйста, не указывайте в своих вопросах личную или конфиденциальную информацию.",
        "sw-SW": "Kipengele cha «Uliza AI» kwenye Ramani ya Rasilimali ya Switchboard hutumia akili bandia (AI) kujibu maswali na kupendekeza huduma kutoka kwenye ramani. Si wakili, mfanyakazi wa kesi, wala mtaalamu mwingine, na hakifanyi maamuzi kuhusu kustahili kwako huduma au manufaa yoyote. Majibu yanaweza kuwa pungufu au ya zamani, kwa hivyo tafadhali wasiliana moja kwa moja na huduma husika ili kuthibitisha saa za kazi, eneo, na masharti. Tafadhali usijumuishe taarifa binafsi au nyeti katika maswali yako.",
        "th": "ฟีเจอร์ «ถาม AI» บนแผนที่ทรัพยากรของ Switchboard ใช้ปัญญาประดิษฐ์เพื่อตอบคำถามและแนะนำบริการจากแผนที่ ฟีเจอร์นี้ไม่ใช่ทนายความ เจ้าหน้าที่ดูแลเคส หรือผู้เชี่ยวชาญอื่น และไม่ได้ตัดสินว่าคุณมีสิทธิ์ได้รับบริการหรือสวัสดิการใดหรือไม่ คำตอบอาจไม่ครบถ้วนหรือล้าสมัย โปรดติดต่อบริการนั้นโดยตรงเพื่อยืนยันเวลาทำการ สถานที่ และข้อกำหนด โปรดอย่าใส่ข้อมูลส่วนบุคคลหรือข้อมูลที่ละเอียดอ่อนในคำถามของคุณ",
        "uk-UK": "Функція «Запитати ШІ» на карті ресурсів Switchboard використовує штучний інтелект, щоб відповідати на запитання та пропонувати послуги з карти. Він не є юристом, соціальним працівником чи іншим фахівцем і не ухвалює рішень щодо того, чи маєте ви право на якусь послугу або допомогу. Відповіді можуть бути неповними або застарілими, тому, будь ласка, зв'яжіться з організацією безпосередньо, щоб уточнити години роботи, адресу та вимоги. Будь ласка, не вказуйте у своїх запитаннях особисту чи конфіденційну інформацію.",
        "vi-VN": "Tính năng Hỏi AI trên Bản đồ Nguồn lực Switchboard sử dụng trí tuệ nhân tạo để trả lời câu hỏi và gợi ý các dịch vụ trên bản đồ. Đây không phải là luật sư, nhân viên xã hội hay chuyên gia nào khác, và không đưa ra quyết định về việc bạn có đủ điều kiện nhận bất kỳ dịch vụ hoặc quyền lợi nào hay không. Câu trả lời có thể chưa đầy đủ hoặc đã lỗi thời, vì vậy vui lòng liên hệ trực tiếp với dịch vụ để xác nhận giờ làm việc, địa điểm và yêu cầu. Vui lòng không đưa thông tin cá nhân hoặc nhạy cảm vào câu hỏi của bạn.",
        "ko-KR": "Switchboard 자원 지도의 'AI에게 질문하기' 기능은 인공지능을 사용하여 질문에 답하고 지도에 있는 서비스를 추천합니다. 이 기능은 변호사, 사례 담당자 또는 기타 전문가가 아니며, 귀하가 어떤 서비스나 혜택을 받을 자격이 있는지에 대해 결정을 내리지 않습니다. 답변이 불완전하거나 최신이 아닐 수 있으므로, 운영 시간, 위치, 요건은 해당 서비스에 직접 문의하여 확인하시기 바랍니다. 질문에 개인정보나 민감한 정보를 포함하지 마십시오.",
        "zh-CN": "Switchboard 资源地图上的“询问 AI”功能使用人工智能回答问题，并从地图中推荐服务。它不是律师、个案工作者或其他专业人士，也不会就您是否有资格获得任何服务或福利作出决定。回答可能不完整或已过时，请直接联系相关服务机构，确认营业时间、地点和要求。请勿在提问中包含个人信息或敏感信息。",
        "fr-HT": "La fonction « Demander à l'IA » de la carte des ressources Switchboard utilise l'intelligence artificielle pour répondre à vos questions et suggérer des services à partir de la carte. Elle n'est ni un avocat, ni un travailleur social, ni un autre professionnel, et elle ne prend aucune décision concernant votre admissibilité à un service ou à une prestation. Les réponses peuvent être incomplètes ou obsolètes ; veuillez donc contacter directement le service pour confirmer les horaires, l'adresse et les conditions. Veuillez ne pas inclure d'informations personnelles ou sensibles dans vos questions.",
        "fa-FA": "قابلیت «پرسش از هوش مصنوعی» در نقشه منابع Switchboard از هوش مصنوعی برای پاسخ به پرسش‌ها و پیشنهاد خدمات از روی نقشه استفاده می‌کند. این قابلیت وکیل، کارمند پرونده یا متخصص دیگری نیست و درباره واجد شرایط بودن شما برای هیچ خدمت یا مزیتی تصمیم نمی‌گیرد. پاسخ‌ها ممکن است ناقص یا قدیمی باشند، بنابراین لطفاً برای تأیید ساعات کاری، موقعیت و شرایط، مستقیماً با آن خدمت تماس بگیرید. لطفاً در پرسش‌های خود اطلاعات شخصی یا حساس وارد نکنید."
    },
    aiDisclaimerData: {
        "en-US": "Your chat history stays in your browser for the current session, and you can start a new conversation at any time. We collect the questions you ask and the answers you receive, along with general usage information such as language and which services you click, to understand how the map is used and to improve it. We collect your approximate location only if you give the website permission to share it, or if you type it into the chat. We do not sell this information or use it for any other purpose, and we do not share it with anyone outside the International Rescue Committee and the software services we use to generate responses.",
        "am": "የውይይት ታሪክዎ ለአሁኑ ክፍለ ጊዜ በአሳሽዎ ውስጥ ይቆያል፤ በማንኛውም ጊዜ አዲስ ውይይት መጀመር ይችላሉ። ካርታው እንዴት ጥቅም ላይ እንደሚውል ለመረዳትና ለማሻሻል የሚጠይቋቸውን ጥያቄዎች እና የሚያገኟቸውን መልሶች እንዲሁም እንደ ቋንቋና የሚጫኑባቸው አገልግሎቶች ያሉ አጠቃላይ የአጠቃቀም መረጃዎችን እንሰበስባለን። ግምታዊ አካባቢዎን የምንሰበስበው ድረ ገጹ እንዲያጋራ ፈቃድ ከሰጡ ወይም በውይይቱ ውስጥ ከጻፉት ብቻ ነው። ይህንን መረጃ አንሸጥም ወይም ለሌላ ዓላማ አንጠቀምበትም፤ እንዲሁም ከአለም አቀፍ አድን ኮሚቴ (IRC) እና ምላሾችን ለማመንጨት ከምንጠቀምባቸው የሶፍትዌር አገልግሎቶች ውጭ ለማንም አናጋራውም።",
        "ar-SA": "يبقى سجل محادثتك في متصفحك طوال الجلسة الحالية، ويمكنك بدء محادثة جديدة في أي وقت. نجمع الأسئلة التي تطرحها والإجابات التي تتلقاها، إلى جانب معلومات الاستخدام العامة مثل اللغة والخدمات التي تنقر عليها، لفهم كيفية استخدام الخريطة وتحسينها. ولا نجمع موقعك التقريبي إلا إذا منحت الموقع الإلكتروني إذنًا بمشاركته أو إذا كتبته في المحادثة. نحن لا نبيع هذه المعلومات ولا نستخدمها لأي غرض آخر، ولا نشاركها مع أي جهة خارج لجنة الإنقاذ الدولية وخدمات البرمجيات التي نستخدمها لإنشاء الردود.",
        "fr-FR": "L'historique de votre conversation reste dans votre navigateur pendant la session en cours, et vous pouvez démarrer une nouvelle conversation à tout moment. Nous collectons les questions que vous posez et les réponses que vous recevez, ainsi que des informations générales d'utilisation, telles que la langue et les services sur lesquels vous cliquez, afin de comprendre comment la carte est utilisée et de l'améliorer. Nous ne collectons votre position approximative que si vous autorisez le site à la partager ou si vous la saisissez dans la conversation. Nous ne vendons pas ces informations et ne les utilisons à aucune autre fin, et nous ne les partageons avec personne en dehors du Comité international de secours (IRC) et des services logiciels que nous utilisons pour générer les réponses.",
        "es-ES": "El historial de su conversación permanece en su navegador durante la sesión actual y puede iniciar una nueva conversación en cualquier momento. Recopilamos las preguntas que formula y las respuestas que recibe, junto con información general de uso, como el idioma y los servicios en los que hace clic, para comprender cómo se usa el mapa y mejorarlo. Recopilamos su ubicación aproximada únicamente si usted da permiso al sitio web para compartirla o si la escribe en el chat. No vendemos esta información ni la usamos para ningún otro fin, y no la compartimos con nadie ajeno al Comité Internacional de Rescate (IRC) y a los servicios de software que utilizamos para generar las respuestas.",
        "so-SO": "Taariikhda sheekadaada waxay ku jirtaa biraawsarkaaga inta lagu jiro kulankan, waxaadna bilaabi kartaa wada hadal cusub wakhti kasta. Waxaan ururinnaa su'aalaha aad weydiiso iyo jawaabaha aad hesho, iyo sidoo kale macluumaadka guud ee isticmaalka sida luqadda iyo adeegyada aad gujiso, si aan u fahanno sida khariidadda loo isticmaalo oo aan u hagaajinno. Waxaan ururinnaa meeshaada la qiyaasay kaliya haddii aad website-ka siisay ogolaansho aad ku wadaagto ama haddii aad ku qorto sheekada. Ma iibino macluumaadkan mana u isticmaalno ujeeddo kale, mana la wadaagno cid ka baxsan Guddiga Samatabbixinta Caalamiga ah (IRC) iyo adeegyada software-ka ee aan u isticmaalno soo saarista jawaabaha.",
        "ur-UR": "آپ کی چیٹ کی تاریخ موجودہ سیشن کے لیے آپ کے براؤزر میں رہتی ہے، اور آپ کسی بھی وقت نئی گفتگو شروع کر سکتے ہیں۔ ہم آپ کے پوچھے گئے سوالات اور موصول ہونے والے جوابات، نیز عمومی استعمال کی معلومات جیسے زبان اور آپ کن خدمات پر کلک کرتے ہیں، جمع کرتے ہیں تاکہ سمجھ سکیں کہ میپ کیسے استعمال ہوتا ہے اور اسے بہتر بنا سکیں۔ ہم آپ کا تخمینی مقام صرف اسی صورت میں جمع کرتے ہیں جب آپ ویب سائٹ کو اسے شیئر کرنے کی اجازت دیں یا آپ اسے چیٹ میں خود لکھیں۔ ہم یہ معلومات فروخت نہیں کرتے اور نہ کسی دوسرے مقصد کے لیے استعمال کرتے ہیں، اور انٹرنیشنل ریسکیو کمیٹی (IRC) اور جوابات تیار کرنے کے لیے استعمال ہونے والی سافٹ ویئر خدمات کے علاوہ کسی کے ساتھ شیئر نہیں کرتے۔",
        "ht": "Istwa chat ou a rete nan navigatè ou pou sesyon aktyèl la, epi ou ka kòmanse yon nouvo konvèsasyon nenpòt ki lè. Nou kolekte kesyon ou poze yo ak repons ou resevwa yo, ansanm ak enfòmasyon jeneral sou itilizasyon tankou lang ak sèvis ou klike sou yo, pou nou konprann ki jan yo itilize kat la epi amelyore li. Nou kolekte lokalizasyon apwoksimatif ou sèlman si ou bay sit entènèt la pèmisyon pou pataje li oswa si ou tape li nan chat la. Nou pa vann enfòmasyon sa yo ni itilize yo pou okenn lòt rezon, e nou pa pataje yo ak pesonn andeyò Komite Entènasyonal Sekou (IRC) ak sèvis lojisyèl nou itilize pou jenere repons yo.",
        "bn": "আপনার চ্যাটের ইতিহাস বর্তমান সেশনের জন্য আপনার ব্রাউজারেই থাকে, এবং আপনি যেকোনো সময় নতুন কথোপকথন শুরু করতে পারেন। ম্যাপটি কীভাবে ব্যবহৃত হচ্ছে তা বুঝতে এবং এটি উন্নত করতে আমরা আপনার করা প্রশ্ন ও পাওয়া উত্তর, পাশাপাশি ভাষা এবং আপনি কোন পরিষেবায় ক্লিক করেন এমন সাধারণ ব্যবহারের তথ্য সংগ্রহ করি। আপনি ওয়েবসাইটকে অনুমতি দিলে বা চ্যাটে নিজে লিখলেই কেবল আমরা আপনার আনুমানিক অবস্থান সংগ্রহ করি। আমরা এই তথ্য বিক্রি করি না বা অন্য কোনো উদ্দেশ্যে ব্যবহার করি না, এবং ইন্টারন্যাশনাল রেসকিউ কমিটি (IRC) ও উত্তর তৈরিতে ব্যবহৃত সফটওয়্যার পরিষেবা ছাড়া অন্য কারও সাথে শেয়ার করি না।",
        "my": "သင့်စကားဝိုင်းမှတ်တမ်းသည် လက်ရှိအစီအစဉ်အတွက် သင့်ဘရောက်ဇာထဲတွင် ရှိနေပြီး မည်သည့်အချိန်တွင်မဆို စကားပြောဆိုမှုအသစ် စတင်နိုင်သည်။ မြေပုံကို မည်သို့အသုံးပြုသည်ကို နားလည်ရန်နှင့် တိုးတက်အောင်လုပ်ရန် သင်မေးသောမေးခွန်းများ၊ သင်ရရှိသောအဖြေများနှင့်အတူ ဘာသာစကားနှင့် သင်နှိပ်သည့်ဝန်ဆောင်မှုများကဲ့သို့ အထွေထွေအသုံးပြုမှုအချက်အလက်များကို ကျွန်ုပ်တို့ စုဆောင်းသည်။ ဝက်ဘ်ဆိုက်ကို မျှဝေခွင့်ပေးထားလျှင် သို့မဟုတ် စကားပြောဆိုမှုတွင် ကိုယ်တိုင်ရိုက်ထည့်လျှင်သာ သင့်ခန့်မှန်းတည်နေရာကို စုဆောင်းသည်။ ဤအချက်အလက်ကို ရောင်းချခြင်း သို့မဟုတ် အခြားရည်ရွယ်ချက်အတွက် အသုံးပြုခြင်း မပြုပါ၊ နိုင်ငံတကာကယ်ဆယ်ရေးကော်မတီ (IRC) နှင့် အဖြေများထုတ်လုပ်ရန် အသုံးပြုသော ဆော့ဖ်ဝဲဝန်ဆောင်မှုများမှလွဲ၍ မည်သူနှင့်မျှ မမျှဝေပါ။",
        "cs": "Historie vašeho chatu zůstává po dobu aktuální relace ve vašem prohlížeči a novou konverzaci můžete zahájit kdykoli. Shromažďujeme otázky, které klademe, a odpovědi, které získáte, spolu s obecnými údaji o používání, jako je jazyk a služby, na které kliknete, abychom pochopili, jak se mapa používá, a mohli ji zlepšovat. Vaši přibližnou polohu shromažďujeme pouze tehdy, pokud webu udělíte povolení ji sdílet, nebo pokud ji zadáte do chatu. Tyto informace neprodáváme ani je nepoužíváme k žádnému jinému účelu a nesdílíme je s nikým mimo Mezinárodní záchranný výbor (IRC) a softwarové služby, které využíváme ke generování odpovědí.",
        "fa-AF": "تاریخچه گفتگوی شما برای نشست فعلی در مرورگر شما باقی می‌ماند و می‌توانید هر زمان گفتگوی جدیدی را شروع کنید. ما پرسش‌هایی که می‌پرسید و پاسخ‌هایی که دریافت می‌کنید، همراه با اطلاعات کلی استفاده مانند زبان و خدماتی که روی آن‌ها کلیک می‌کنید را جمع‌آوری می‌کنیم تا بفهمیم نقشه چگونه استفاده می‌شود و آن را بهبود دهیم. موقعیت تقریبی شما را فقط زمانی جمع‌آوری می‌کنیم که به وب‌سایت اجازه اشتراک‌گذاری آن را بدهید یا آن را در گفتگو تایپ کنید. ما این اطلاعات را نمی‌فروشیم و برای هیچ هدف دیگری استفاده نمی‌کنیم و آن را با هیچ‌کس خارج از کمیته بین‌المللی نجات (IRC) و خدمات نرم‌افزاری‌ای که برای تولید پاسخ‌ها استفاده می‌کنیم به اشتراک نمی‌گذاریم.",
        "de-DE": "Ihr Chatverlauf bleibt für die aktuelle Sitzung in Ihrem Browser gespeichert, und Sie können jederzeit ein neues Gespräch beginnen. Wir erfassen die Fragen, die Sie stellen, und die Antworten, die Sie erhalten, sowie allgemeine Nutzungsdaten wie die Sprache und die Angebote, auf die Sie klicken, um zu verstehen, wie die Karte genutzt wird, und sie zu verbessern. Ihren ungefähren Standort erfassen wir nur, wenn Sie der Website die Freigabe erlauben oder ihn selbst in den Chat eingeben. Wir verkaufen diese Informationen nicht, verwenden sie nicht für andere Zwecke und geben sie nicht an Dritte außerhalb des International Rescue Committee (IRC) und der Softwaredienste weiter, die wir zur Erstellung der Antworten nutzen.",
        "el": "Το ιστορικό της συνομιλίας σας παραμένει στον περιηγητή σας για την τρέχουσα συνεδρία και μπορείτε να ξεκινήσετε νέα συνομιλία ανά πάσα στιγμή. Συλλέγουμε τις ερωτήσεις που κάνετε και τις απαντήσεις που λαμβάνετε, μαζί με γενικές πληροφορίες χρήσης, όπως η γλώσσα και οι υπηρεσίες στις οποίες κάνετε κλικ, ώστε να κατανοούμε πώς χρησιμοποιείται ο χάρτης και να τον βελτιώνουμε. Συλλέγουμε την κατά προσέγγιση τοποθεσία σας μόνο εάν δώσετε άδεια στον ιστότοπο να την μοιραστεί ή εάν την πληκτρολογήσετε στη συνομιλία. Δεν πουλάμε αυτές τις πληροφορίες ούτε τις χρησιμοποιούμε για οποιονδήποτε άλλο σκοπό, και δεν τις μοιραζόμαστε με κανέναν εκτός της Διεθνούς Επιτροπής Διάσωσης (IRC) και των υπηρεσιών λογισμικού που χρησιμοποιούμε για τη δημιουργία των απαντήσεων.",
        "ha-HA": "Tarihin hirarku yana zama a cikin burauzarku a lokacin zaman na yanzu, kuma kuna iya fara sabuwar tattaunawa a kowane lokaci. Muna tattara tambayoyin da kuke yi da amsoshin da kuke samu, tare da bayanan amfani na gaba ɗaya kamar harshe da ayyukan da kuke dannawa, don mu fahimci yadda ake amfani da taswirar kuma mu inganta ta. Muna tattara kusan wurin da kuke ne kawai idan kun ba shafin izinin raba shi ko kuma idan kun rubuta shi a cikin hirar. Ba ma sayar da wannan bayani ko amfani da shi don wata manufa ta daban, kuma ba ma raba shi da kowa a wajen Kwamitin Ceto na Duniya (IRC) da ayyukan software da muke amfani da su wajen samar da amsoshi.",
        "hu-HU": "A csevegési előzményei az aktuális munkamenet idejére a böngészőjében maradnak, és bármikor új beszélgetést indíthat. Gyűjtjük az Ön által feltett kérdéseket és a kapott válaszokat, valamint az általános használati adatokat, például a nyelvet és azt, hogy mely szolgáltatásokra kattint, hogy megértsük a térkép használatát és fejleszthessük azt. Hozzávetőleges tartózkodási helyét csak akkor gyűjtjük, ha engedélyt ad a weboldalnak a megosztására, vagy ha beírja a csevegésbe. Ezeket az információkat nem adjuk el és nem használjuk más célra, és nem osztjuk meg senkivel a Nemzetközi Mentőbizottságon (IRC) és a válaszok előállításához használt szoftverszolgáltatásokon kívül.",
        "it-IT": "La cronologia della chat rimane nel tuo browser per la sessione in corso e puoi avviare una nuova conversazione in qualsiasi momento. Raccogliamo le domande che poni e le risposte che ricevi, insieme a informazioni generali sull'utilizzo come la lingua e i servizi su cui fai clic, per capire come viene usata la mappa e per migliorarla. Raccogliamo la tua posizione approssimativa solo se concedi al sito web l'autorizzazione a condividerla o se la scrivi nella chat. Non vendiamo queste informazioni né le utilizziamo per altri scopi, e non le condividiamo con nessuno al di fuori dell'International Rescue Committee (IRC) e dei servizi software che utilizziamo per generare le risposte.",
        "ln-LN": "Lisolo na yo ezali kotikala na navigateur na yo mpo na ngonga oyo ozali na yango, mpe okoki ko-banda lisolo ya sika ntango nyonso. Tozwaka mituna oyo ozali kotuna mpe biyano oyo ozwi, elongo na ba informations ya kosalela lokola monoko mpe misala oyo ozali kopusa, mpo na kososola ndenge mapi esalelami mpe kobongisa yango. Tozwaka esika oyo ozali na kolimbola kaka soki opesi site ndingisa ya kokabola yango to soki okomi yango na lisolo. Tozali koteka ba informations oyo te mpe tozali kosalela yango mpo na likambo mosusu te, mpe tozali kokabola yango na moto mosusu te longola Komite ya Mikili Nyonso ya Lisalisi (IRC) mpe misala ya logiciel oyo tosalelaka mpo na kobongisa biyano.",
        "ps-PS": "ستاسو د چت تاریخچه د اوسنۍ ناستې لپاره ستاسو په براوزر کې پاتې کېږي، او تاسو کولی شئ هر وخت نوې خبرې اترې پیل کړئ. موږ هغه پوښتنې چې تاسو یې کوئ او هغه ځوابونه چې تاسو یې ترلاسه کوئ، سره د عمومي کارونې معلوماتو لکه ژبه او هغه خدمتونه چې تاسو یې کلیک کوئ، راټولوو، څو پوه شو چې نقشه څنګه کارول کېږي او ښه یې کړو. موږ ستاسو نږدې موقعیت یوازې هغه وخت راټولوو چې تاسو وېب پاڼې ته د شریکولو اجازه ورکړئ یا یې په چت کې ولیکئ. موږ دا معلومات نه پلوري او نه یې د بل هدف لپاره کاروو، او له نړیوالې ژغورنې کمیټې (IRC) او د ځوابونو د جوړولو لپاره د کارېدونکو سافټویر خدمتونو پرته له بل چا سره یې نه شریکوو.",
        "ru-RU": "История вашего чата хранится в вашем браузере в течение текущего сеанса, и вы можете начать новый разговор в любое время. Мы собираем задаваемые вами вопросы и получаемые ответы, а также общие данные об использовании, такие как язык и услуги, по которым вы переходите, чтобы понимать, как используется карта, и улучшать её. Ваше примерное местоположение мы собираем только в том случае, если вы разрешите сайту передать его или введёте его в чат. Мы не продаём эту информацию и не используем её ни для каких других целей, а также не передаём её никому, кроме Международного спасательного комитета (IRC) и программных сервисов, которые мы используем для формирования ответов.",
        "sw-SW": "Historia ya mazungumzo yako hubaki kwenye kivinjari chako kwa kipindi cha sasa, na unaweza kuanza mazungumzo mapya wakati wowote. Tunakusanya maswali unayouliza na majibu unayopokea, pamoja na taarifa za jumla za matumizi kama lugha na huduma unazobofya, ili kuelewa jinsi ramani inavyotumika na kuiboresha. Tunakusanya eneo lako la makadirio pale tu unapoipa tovuti ruhusa ya kulishiriki au unapoliandika kwenye gumzo. Hatuuzi taarifa hizi wala kuzitumia kwa madhumuni mengine yoyote, na hatuzishiriki na mtu yeyote nje ya Kamati ya Kimataifa ya Uokoaji (IRC) na huduma za programu tunazotumia kutoa majibu.",
        "th": "ประวัติการแชทของคุณจะอยู่ในเบราว์เซอร์ของคุณตลอดช่วงเซสชันปัจจุบัน และคุณสามารถเริ่มการสนทนาใหม่ได้ทุกเมื่อ เราเก็บคำถามที่คุณถามและคำตอบที่คุณได้รับ รวมถึงข้อมูลการใช้งานทั่วไป เช่น ภาษาและบริการที่คุณคลิก เพื่อทำความเข้าใจว่ามีการใช้แผนที่อย่างไรและเพื่อปรับปรุงให้ดีขึ้น เราจะเก็บตำแหน่งโดยประมาณของคุณเฉพาะเมื่อคุณอนุญาตให้เว็บไซต์แชร์ หรือเมื่อคุณพิมพ์ลงในแชทเอง เราไม่ขายข้อมูลนี้หรือนำไปใช้เพื่อวัตถุประสงค์อื่น และไม่แชร์กับผู้ใดนอกจากคณะกรรมการกู้ภัยระหว่างประเทศ (IRC) และบริการซอฟต์แวร์ที่เราใช้สร้างคำตอบ",
        "uk-UK": "Історія вашого чату зберігається у вашому браузері протягом поточного сеансу, і ви можете почати нову розмову будь-коли. Ми збираємо запитання, які ви ставите, і відповіді, які ви отримуєте, а також загальні дані про використання, як-от мову та послуги, на які ви переходите, щоб розуміти, як використовується карта, і вдосконалювати її. Ваше приблизне місцезнаходження ми збираємо лише тоді, коли ви дозволяєте сайту поділитися ним або вводите його в чат. Ми не продаємо цю інформацію й не використовуємо її для будь-яких інших цілей, а також не передаємо її нікому, окрім Міжнародного комітету порятунку (IRC) та програмних сервісів, які ми використовуємо для формування відповідей.",
        "vi-VN": "Lịch sử trò chuyện của bạn được lưu trong trình duyệt của bạn trong phiên hiện tại và bạn có thể bắt đầu cuộc trò chuyện mới bất cứ lúc nào. Chúng tôi thu thập các câu hỏi bạn đặt ra và câu trả lời bạn nhận được, cùng với thông tin sử dụng chung như ngôn ngữ và các dịch vụ bạn nhấp vào, để hiểu cách bản đồ được sử dụng và cải thiện nó. Chúng tôi chỉ thu thập vị trí gần đúng của bạn nếu bạn cho phép trang web chia sẻ hoặc nếu bạn tự nhập vào cuộc trò chuyện. Chúng tôi không bán thông tin này hay sử dụng cho bất kỳ mục đích nào khác, và không chia sẻ với bất kỳ ai ngoài Ủy ban Cứu trợ Quốc tế (IRC) và các dịch vụ phần mềm chúng tôi dùng để tạo câu trả lời.",
        "ko-KR": "채팅 기록은 현재 세션 동안 브라우저에 저장되며, 언제든지 새 대화를 시작할 수 있습니다. 저희는 지도가 어떻게 사용되는지 파악하고 개선하기 위해 귀하가 하는 질문과 받은 답변, 그리고 언어 및 클릭한 서비스와 같은 일반적인 사용 정보를 수집합니다. 대략적인 위치는 귀하가 웹사이트에 공유를 허용하거나 채팅에 직접 입력한 경우에만 수집합니다. 이 정보는 판매하지 않으며 다른 목적으로 사용하지 않고, 국제구조위원회(IRC)와 답변 생성에 사용하는 소프트웨어 서비스 외에는 누구와도 공유하지 않습니다.",
        "zh-CN": "您的聊天记录在当前会话期间保存在您的浏览器中，您可以随时开始新的对话。我们会收集您提出的问题和收到的回答，以及语言和您点击的服务等一般使用信息，以了解地图的使用情况并加以改进。只有在您授权网站共享或在聊天中自行输入的情况下，我们才会收集您的大致位置。我们不会出售这些信息，也不会将其用于任何其他目的，除国际救援委员会（IRC）和我们用于生成回答的软件服务外，不会与任何人共享。",
        "fr-HT": "L'historique de votre conversation reste dans votre navigateur pendant la session en cours, et vous pouvez démarrer une nouvelle conversation à tout moment. Nous collectons les questions que vous posez et les réponses que vous recevez, ainsi que des informations générales d'utilisation, telles que la langue et les services sur lesquels vous cliquez, afin de comprendre comment la carte est utilisée et de l'améliorer. Nous ne collectons votre position approximative que si vous autorisez le site à la partager ou si vous la saisissez dans la conversation. Nous ne vendons pas ces informations et ne les utilisons à aucune autre fin, et nous ne les partageons avec personne en dehors du Comité international de secours (IRC) et des services logiciels que nous utilisons pour générer les réponses.",
        "fa-FA": "تاریخچه گفتگوی شما برای نشست فعلی در مرورگر شما باقی می‌ماند و می‌توانید هر زمان گفتگوی جدیدی را شروع کنید. ما پرسش‌هایی که می‌پرسید و پاسخ‌هایی که دریافت می‌کنید، همراه با اطلاعات کلی استفاده مانند زبان و خدماتی که روی آن‌ها کلیک می‌کنید را جمع‌آوری می‌کنیم تا بفهمیم نقشه چگونه استفاده می‌شود و آن را بهبود دهیم. موقعیت تقریبی شما را فقط زمانی جمع‌آوری می‌کنیم که به وب‌سایت اجازه اشتراک‌گذاری آن را بدهید یا آن را در گفتگو تایپ کنید. ما این اطلاعات را نمی‌فروشیم و برای هیچ هدف دیگری استفاده نمی‌کنیم و آن را با هیچ‌کس خارج از کمیته بین‌المللی نجات (IRC) و خدمات نرم‌افزاری‌ای که برای تولید پاسخ‌ها استفاده می‌کنیم به اشتراک نمی‌گذاریم."
    },
    aiDisclaimerContact: {
        "en-US": "If you have questions about this notice, contact Switchboard at",
        "am": "ስለዚህ ማሳሰቢያ ጥያቄዎች ካሉዎት Switchboardን በዚህ ያነጋግሩ፦",
        "ar-SA": "إذا كانت لديك أسئلة حول هذا الإشعار، فتواصل مع Switchboard عبر:",
        "fr-FR": "Si vous avez des questions sur cet avis, contactez Switchboard à l'adresse suivante :",
        "es-ES": "Si tiene preguntas sobre este aviso, póngase en contacto con Switchboard en:",
        "so-SO": "Haddii aad su'aalo ka qabto ogeysiiskan, la xiriir Switchboard cinwaanka:",
        "ur-UR": "اگر آپ کے اس نوٹس کے بارے میں سوالات ہیں تو Switchboard سے یہاں رابطہ کریں:",
        "ht": "Si ou gen kesyon sou avi sa a, kontakte Switchboard nan:",
        "bn": "এই বিজ্ঞপ্তি সম্পর্কে আপনার কোনো প্রশ্ন থাকলে Switchboard-এর সাথে যোগাযোগ করুন:",
        "my": "ဤသတိပေးချက်နှင့်ပတ်သက်၍ မေးခွန်းများရှိပါက Switchboard ကို ဤနေရာတွင် ဆက်သွယ်ပါ -",
        "cs": "Pokud máte k tomuto upozornění dotazy, kontaktujte Switchboard na adrese:",
        "fa-AF": "اگر درباره این اطلاعیه پرسشی دارید، با Switchboard از طریق این نشانی تماس بگیرید:",
        "de-DE": "Wenn Sie Fragen zu diesem Hinweis haben, wenden Sie sich an Switchboard unter:",
        "el": "Εάν έχετε ερωτήσεις σχετικά με αυτήν την ειδοποίηση, επικοινωνήστε με το Switchboard στη διεύθυνση:",
        "ha-HA": "Idan kuna da tambayoyi game da wannan sanarwa, ku tuntuɓi Switchboard a:",
        "hu-HU": "Ha kérdése van ezzel a tájékoztatóval kapcsolatban, forduljon a Switchboardhoz a következő címen:",
        "it-IT": "In caso di domande su questa informativa, contatta Switchboard all'indirizzo:",
        "ln-LN": "Soki ozali na mituna na ntina ya sango oyo, benga Switchboard na:",
        "ps-PS": "که ددې خبرتیا په اړه پوښتنې لرئ، له Switchboard سره دلته اړیکه ونیسئ:",
        "ru-RU": "Если у вас есть вопросы по поводу этого уведомления, свяжитесь со Switchboard по адресу:",
        "sw-SW": "Ikiwa una maswali kuhusu notisi hii, wasiliana na Switchboard kupitia:",
        "th": "หากมีคำถามเกี่ยวกับประกาศนี้ โปรดติดต่อ Switchboard ที่:",
        "uk-UK": "Якщо у вас є запитання щодо цього повідомлення, зверніться до Switchboard за адресою:",
        "vi-VN": "Nếu bạn có câu hỏi về thông báo này, vui lòng liên hệ Switchboard tại:",
        "ko-KR": "이 안내에 대해 문의 사항이 있으시면 Switchboard에 연락해 주십시오:",
        "zh-CN": "如果您对本通知有任何疑问，请联系 Switchboard：",
        "fr-HT": "Si vous avez des questions sur cet avis, contactez Switchboard à l'adresse suivante :",
        "fa-FA": "اگر درباره این اطلاعیه پرسشی دارید، با Switchboard از طریق این نشانی تماس بگیرید:"
    },
    aiGreeting: {
        "en-US": "Hi! I can help you find services like food support, housing help, or mental health resources.",
        am: "ሰላም! እንደ የምግብ ድጋፍ፣ የመኖሪያ እገዛ ወይም የአእምሮ ጤና መረጃዎች ያሉ አገልግሎቶችን እንድታገኙ ልረዳዎ እችላለሁ።",
        "ar-SA": "مرحبًا! يمكنني مساعدتك في العثور على خدمات مثل دعم الغذاء أو المساعدة في الإسكان أو موارد الصحة النفسية.",
        "fr-FR": "Bonjour ! Je peux vous aider à trouver des services comme l'aide alimentaire, l'aide au logement ou des ressources en santé mentale.",
        "es-ES": "¡Hola! Puedo ayudarte a encontrar servicios como apoyo alimentario, ayuda de vivienda o recursos de salud mental.",
        "so-SO": "Salaan! Waxaan kaa caawin karaa inaad hesho adeegyo sida taageerada cuntada, caawinta guryeynta, ama ilaha caafimaadka dhimirka.",
        "ur-UR": "ہیلو! میں آپ کو کھانے کی مدد، رہائشی مدد، یا ذہنی صحت کے وسائل جیسی خدمات تلاش کرنے میں مدد کر سکتا ہوں۔",
        "ht": "Bonjou! Mwen ka ede ou jwenn sèvis tankou sipò alimantè, èd pou lojman, oswa resous sante mantal.",
        "fr-HT": "Bonjou! Mwen ka ede ou jwenn sèvis tankou sipò alimantè, èd pou lojman, oswa resous sante mantal.",
        "bn": "হ্যালো! আমি আপনাকে খাবার সহায়তা, আবাসন সহায়তা বা মানসিক স্বাস্থ্য সংক্রান্ত সম্পদের মতো সেবা খুঁজে পেতে সাহায্য করতে পারি।",
        "my": "မင်္ဂလာပါ! အစားအသောက်အကူအညီ၊ အိမ်ရာအကူအညီ သို့မဟုတ် စိတ်ကျန်းမာရေးအရင်းအမြစ်များကဲ့သို့ ဝန်ဆောင်မှုများကို ရှာဖွေရန် ကူညီပေးနိုင်ပါသည်။",
        "cs": "Ahoj! Mohu vám pomoci najít služby jako potravinová podpora, pomoc s bydlením nebo zdroje duševního zdraví.",
        "fa-AF": "سلام! می‌توانم به شما کمک کنم خدمات مانند حمایت غذایی، کمک مسکن یا منابع صحت روانی را پیدا کنید.",
        "fa-FA": "سلام! می‌توانم به شما کمک کنم خدماتی مانند حمایت غذایی، کمک مسکن یا منابع سلامت روان را پیدا کنید.",
        "de-DE": "Hallo! Ich kann Ihnen helfen, Dienste wie Lebensmittelhilfe, Wohnungsunterstützung oder Ressourcen für die psychische Gesundheit zu finden.",
        "el": "Γεια! Μπορώ να σας βοηθήσω να βρείτε υπηρεσίες όπως επισιτιστική στήριξη, βοήθεια στέγασης ή πόρους ψυχικής υγείας.",
        "ha-HA": "Sannu! Zan iya taimaka muku nemo ayyuka kamar tallafin abinci, taimakon gida, ko albarkatun lafiyar hankali.",
        "hu-HU": "Szia! Segíthetek olyan szolgáltatásokat találni, mint az élelmiszer-támogatás, a lakhatási segítség vagy a mentális egészség erőforrásai.",
        "it-IT": "Ciao! Posso aiutarti a trovare servizi come supporto alimentare, aiuto per l'alloggio o risorse per la salute mentale.",
        "KAU": "Sannu! Zan iya taimaka muku nemo ayyuka kamar tallafin abinci, taimakon gida, ko albarkatun lafiyar hankali.",
        "ki-KI": "Muraho! Nshobora kukugufasha kubona serivisi nka gufasha ku biribwa, ubufasha bw'amazu, cyangwa ibikoresho by'ubuzima bwo mu mutwe.",
        "ln-LN": "Mbote! Nakoki kosalisa yo kozwa misala lokola lisungi ya bilei, lisungi ya ndako, to biloko ya santé mentale.",
        "ps-PS": "سلام! زه کولی شم تاسو سره مرسته وکړم چې د خواړو ملاتړ، د کور مرستې، یا د رواني روغتیا سرچینو په څیر خدمتونه ومومئ.",
        "ru-RU": "Здравствуйте! Я могу помочь вам найти услуги, такие как продовольственная помощь, помощь с жильём или ресурсы по психическому здоровью.",
        "sw-SW": "Habari! Ninaweza kukusaidia kupata huduma kama msaada wa chakula, msaada wa makazi, au rasilimali za afya ya akili.",
        "th": "สวัสดี! ฉันสามารถช่วยคุณค้นหาบริการ เช่น การสนับสนุนด้านอาหาร ความช่วยเหลือด้านที่อยู่อาศัย หรือทรัพยากรด้านสุขภาพจิตได้",
        "uk-UK": "Привіт! Я можу допомогти вам знайти послуги, такі як продовольча підтримка, допомога з житлом або ресурси психічного здоров'я."
    },
    directions: {
        "en-US": "Directions",
        am: "አቅጣጫዎች",
        "ar-SA": "الاتجاهات",
        "fr-FR": "Directions",
        "es-ES": "Direcciones",
        "so-SO": "Jihooyinka",
        "ur-UR": "توجہ",
        "ht": "Direksyon",
        "fr-HT": "Direksyon",
        "bn": "দিকনির্দেশ",
        "my": "မြေပုံတွင်သွားလာရန်အခြေခံမှုများ",
        "cs": "Směrnice",
        "fa-AF": "راهنمایی",
        "fa-FA": "راهنمایی",
        "de-DE": "Richtungen",
        "el": "Διευθύνσεις",
        "ha-HA": "Direksyon",
        "hu-HU": "Irányok",
        "it-IT": "Indicazioni",
        "KAU": "Direksyon",
        
    },
    yourLocation: {
        "en-US": "Your location",
        am: "የእርስዎ ቦታ",
        "ar-SA": "موقعك",
        "fr-FR": "Votre position",
        "es-ES": "Tu ubicación",
        "so-SO": "Goobtaada",
        "ur-UR": "آپ کا مقام",
        "ht": "Kote ou ye",
        "fr-HT": "Kote ou ye",
        "bn": "আপনার অবস্থান",
        "my": "သင့်တည်နေရာ",
        "cs": "Vaše poloha",
        "fa-AF": "موقعیت شما",
        "fa-FA": "موقعیت شما",
        "de-DE": "Ihr Standort",
        "el": "Η τοποθεσία σας",
        "ha-HA": "Wurin ku",
        "hu-HU": "Az Ön helye",
        "it-IT": "La tua posizione",
        "KAU": "Wurin ku",
        "ki-KI": "Mahali pako",
        "ln-LN": "Esika na yo",
        "ps-PS": "ستاسو موقعیت",
        "ru-RU": "Ваше местоположение",
        "sw-SW": "Mahali pako",
        "th": "ตำแหน่งของคุณ",
        "uk-UK": "Ваше місцезнаходження",
    },
    away: {
        "en-US": "away",
        am: "ርቀት",
        "ar-SA": "بعيدًا",
        "fr-FR": "de distance",
        "es-ES": "de distancia",
        "so-SO": "fog",
        "ur-UR": "دور",
        "ht": "lwen",
        "fr-HT": "lwen",
        "bn": "দূরে",
        "my": "အကွာအဝေး",
        "cs": "daleko",
        "fa-AF": "فاصله",
        "fa-FA": "فاصله",
        "de-DE": "entfernt",
        "el": "μακριά",
        "ha-HA": "nisa",
        "hu-HU": "távolságra",
        "it-IT": "di distanza",
        "KAU": "nisa",
        "ki-KI": "mbali",
        "ln-LN": "mosika",
        "ps-PS": "لرې",
        "ru-RU": "отсюда",
        "sw-SW": "mbali",
        "th": "ห่างออกไป",
        "uk-UK": "звідси",
    },
    addOrEditResource: {
        "en-US": "Add or Edit a Resource",
        am: "መረጃ ጨምር ወይም አርትዕ",
        "ar-SA": "إضافة أو تعديل مورد",
        "fr-FR": "Ajouter ou modifier une ressource",
        "es-ES": "Agregar o editar un recurso",
        "so-SO": "Ku dar ama Wax ka beddel Khayraad",
        "ur-UR": "وسائل شامل کریں یا ترمیم کریں",
        "ht": "Ajoute oswa Modifye yon Resous",
        "fr-HT": "Ajoute oswa Modifye yon Resous",
        "bn": "একটি সম্পদ যোগ বা সম্পাদনা করুন",
        "my": "အရင်းအမြစ် ထည့်ပါ သို့မဟုတ် တည်းဖြတ်ပါ",
        "cs": "Přidat nebo upravit zdroj",
        "fa-AF": "افزودن یا ویرایش یک منبع",
        "fa-FA": "افزودن یا ویرایش یک منبع",
        "de-DE": "Ressource hinzufügen oder bearbeiten",
        "el": "Προσθήκη ή επεξεργασία πόρου",
        "ha-HA": "Ƙara ko Gyara Albarkatu",
        "hu-HU": "Erőforrás hozzáadása vagy szerkesztése",
        "it-IT": "Aggiungi o modifica una risorsa",
        "KAU": "Ƙara ko Gyara Albarkatu",
        "ki-KI": "Ongera cyangwa Hindura Ubutunzi",
        "ln-LN": "Bakisa to Bobongola Lisungi",
        "ps-PS": "سرچینه اضافه یا سمون کړئ",
        "ru-RU": "Добавить или изменить ресурс",
        "sw-SW": "Ongeza au Hariri Rasilimali",
        "th": "เพิ่มหรือแก้ไขทรัพยากร",
        "uk-UK": "Додати або редагувати ресурс",
    },
    selectYourLanguage: {
        "en-US": "Select your language",
        "es-ES": "Selecciona tu idioma",
        "ar-SA": "اختر لغتك",
        "fa-AF": "زبان خود را انتخاب کنید",
        "fa-FA": "زبان خود را انتخاب کنید",
        "ps-PS": "خپله ژبه وټاکئ",
        "ur-UR": "اپنی زبان منتخب کریں",
        am: "ቋንቋዎን ይምረጡ",
        "sw-SW": "Chagua lugha yako",
        "uk-UK": "Виберіть свою мову",
        "ht": "Chwazi lang ou",
        "fr-HT": "Choisissez votre langue",
        "fr-FR": "Choisissez votre langue",
        "so-SO": "Dooro luqaddaada",
        "ru-RU": "Выберите язык",
    },
    selectYourLanguageDescription: {
        "en-US": "Choose your preferred language to get started. You can change this anytime.",
        "es-ES": "Elige tu idioma preferido para comenzar. Puedes cambiarlo en cualquier momento.",
        "ar-SA": "اختر لغتك المفضلة للبدء. يمكنك تغييرها في أي وقت.",
        "fa-AF": "برای شروع زبان مورد نظر خود را انتخاب کنید. می‌توانید هر زمان آن را تغییر دهید.",
        "fa-FA": "برای شروع زبان مورد نظر خود را انتخاب کنید. می‌توانید هر زمان آن را تغییر دهید.",
        "ps-PS": "د پیل لپاره خپله خوښې ژبه وټاکئ. تاسو کولی شئ دا هر وخت بدل کړئ.",
        "ur-UR": "شروع کرنے کے لیے اپنی پسندیدہ زبان منتخب کریں۔ آپ اسے کسی بھی وقت تبدیل کر سکتے ہیں۔",
        am: "ለመጀመር የሚፈልጉትን ቋንቋ ይምረጡ። በማንኛውም ጊዜ መቀየር ይችላሉ።",
        "sw-SW": "Chagua lugha unayopendelea ili kuanza. Unaweza kubadilisha hii wakati wowote.",
        "uk-UK": "Виберіть бажану мову, щоб почати. Ви можете змінити її в будь-який час.",
        "ht": "Chwazi lang ou pito pou kòmanse. Ou ka chanje sa nenpòt lè.",
        "fr-HT": "Choisissez votre langue préférée pour commencer. Vous pouvez la changer à tout moment.",
        "fr-FR": "Choisissez votre langue préférée pour commencer. Vous pouvez la changer à tout moment.",
        "so-SO": "Dooro luqadda aad doorbidayso si aad u bilowdo. Waad bedeli kartaa wakhti kasta.",
        "ru-RU": "Выберите предпочитаемый язык, чтобы начать. Вы можете изменить его в любое время.",
    },
    continueLabel: {
        "en-US": "Continue",
        "es-ES": "Continuar",
        "ar-SA": "متابعة",
        "fa-AF": "ادامه",
        "fa-FA": "ادامه",
        "ps-PS": "دوام ورکړئ",
        "ur-UR": "جاری رکھیں",
        am: "ቀጥል",
        "sw-SW": "Endelea",
        "uk-UK": "Продовжити",
        "ht": "Kontinye",
        "fr-HT": "Continuer",
        "fr-FR": "Continuer",
        "so-SO": "Sii wad",
        "ru-RU": "Продолжить",
    },
    serviceProviderDisclaimer: {
        "en-US": "Disclaimer: Please contact providers directly to verify current information. Translations are provided by Google Translate and may not be fully accurate.",
        am: "ማስታወሻ፡ የአሁኑን መረጃ ለማረጋገጥ እባክዎ አቅራቢዎችን በቀጥታ ያግኙ። ትርጉሞች በGoogle Translate የተሰጡ ሲሆኑ ሙሉ በሙሉ ትክክል ላይሆኑ ይችላሉ።",
        "ar-SA": "إخلاء المسؤولية: يُرجى التواصل مع مقدمي الخدمات مباشرة للتحقق من المعلومات الحالية. تُوفر الترجمات بواسطة Google Translate وقد لا تكون دقيقة بالكامل.",
        "fr-FR": "Avertissement : veuillez contacter directement les prestataires pour vérifier les informations actuelles. Les traductions sont fournies par Google Translate et peuvent ne pas être entièrement exactes.",
        "es-ES": "Aviso: comuníquese directamente con los proveedores para verificar la información actual. Las traducciones son proporcionadas por Google Translate y pueden no ser completamente precisas.",
        "so-SO": "Ogeysiis: Fadlan si toos ah ula xiriir bixiyayaasha si aad u xaqiijiso macluumaadka hadda jira. Turjumaadaha waxaa bixiya Google Translate mana noqon karaan kuwo gebi ahaanba sax ah.",
        "ur-UR": "دستبرداری: موجودہ معلومات کی تصدیق کے لیے براہ کرم فراہم کنندگان سے براہ راست رابطہ کریں۔ ترجمے Google Translate فراہم کرتا ہے اور مکمل طور پر درست نہیں ہو سکتے۔",
        "ht": "Avi: Tanpri kontakte founisè yo dirèkteman pou verifye enfòmasyon aktyèl yo. Tradiksyon yo bay pa Google Translate epi yo ka pa totalman egzak.",
        "fr-HT": "Avi: Tanpri kontakte founisè yo dirèkteman pou verifye enfòmasyon aktyèl yo. Tradiksyon yo bay pa Google Translate epi yo ka pa totalman egzak.",
        "bn": "দাবিত্যাগ: বর্তমান তথ্য যাচাই করতে সরাসরি প্রদানকারীদের সাথে যোগাযোগ করুন। অনুবাদ Google Translate প্রদান করে এবং সম্পূর্ণ সঠিক নাও হতে পারে।",
        "my": "သတိပေးချက်- လက်ရှိအချက်အလက်များကို အတည်ပြုရန် ဝန်ဆောင်မှုပေးသူများကို တိုက်ရိုက်ဆက်သွယ်ပါ။ ဘာသာပြန်များကို Google Translate က ပေးထားပြီး အပြည့်အဝ တိကျမှုမရှိနိုင်ပါ။",
        "cs": "Upozornění: Aktuální informace si prosím ověřte přímo u poskytovatelů. Překlady zajišťuje Google Translate a nemusí být zcela přesné.",
        "fa-AF": "سلب مسئولیت: لطفاً برای تأیید اطلاعات فعلی مستقیماً با ارائه‌دهندگان تماس بگیرید. ترجمه‌ها توسط Google Translate ارائه می‌شوند و ممکن است کاملاً دقیق نباشند.",
        "fa-FA": "سلب مسئولیت: لطفاً برای تأیید اطلاعات فعلی مستقیماً با ارائه‌دهندگان تماس بگیرید. ترجمه‌ها توسط Google Translate ارائه می‌شوند و ممکن است کاملاً دقیق نباشند.",
        "de-DE": "Haftungsausschluss: Bitte kontaktieren Sie die Anbieter direkt, um aktuelle Informationen zu überprüfen. Übersetzungen werden von Google Translate bereitgestellt und sind möglicherweise nicht vollständig korrekt.",
        "el": "Αποποίηση ευθύνης: Επικοινωνήστε απευθείας με τους παρόχους για να επαληθεύσετε τις τρέχουσες πληροφορίες. Οι μεταφράσεις παρέχονται από το Google Translate και ενδέχεται να μην είναι πλήρως ακριβείς.",
        "ha-HA": "Sanarwa: Don Allah a tuntubi masu bayarwa kai tsaye don tabbatar da bayanan yanzu. Fassara Google Translate ne ke bayarwa kuma ƙila ba su da cikakken gaskiya.",
        "hu-HU": "Jogi nyilatkozat: Az aktuális információk ellenőrzéséhez kérjük, lépjen kapcsolatba közvetlenül a szolgáltatókkal. A fordításokat a Google Translate biztosítja, és előfordulhat, hogy nem teljesen pontosak.",
        "it-IT": "Avvertenza: contattare direttamente i fornitori per verificare le informazioni aggiornate. Le traduzioni sono fornite da Google Translate e potrebbero non essere del tutto accurate.",
        "KAU": "Sanarwa: Don Allah a tuntubi masu bayarwa kai tsaye don tabbatar da bayanan yanzu. Fassara Google Translate ne ke bayarwa kuma ƙila ba su da cikakken gaskiya.",
        "ki-KI": "Intayo: Nyamuneka vugana n'abatanga serivisi ku buryo butaziguye kugira ngo wemeze amakuru ariho ubu. Ibisesenguye bitangwa na Google Translate kandi birashobora kutaba bihamye neza.",
        "ln-LN": "Likambo ya koboya: Svp benga basali ya service na bango moko mpo na kondima ba information ya lelo. Ba traduction ezwami na Google Translate mpe ekoki kozala te exacte mpenza.",
        "ps-PS": "رد مسئولیت: مهرباني وکړئ د اوسني معلوماتو د تایید لپاره مستقیم له چمتو کوونکو سره اړیکه ونیسئ. ژباړې د Google Translate لخوا وړاندې کیږي او ممکن بشپړ دقیقې نه وي.",
        "ru-RU": "Отказ от ответственности: пожалуйста, свяжитесь напрямую с поставщиками услуг, чтобы проверить актуальную информацию. Переводы предоставлены Google Translate и могут быть не полностью точными.",
        "sw-SW": "Kanusho: Tafadhali wasiliana moja kwa moja na watoa huduma ili kuthibitisha taarifa za sasa. Tafsiri zinatolewa na Google Translate na huenda zisiwe sahihi kikamilifu.",
        "th": "ข้อจำกัดความรับผิดชอบ: โปรดติดต่อผู้ให้บริการโดยตรงเพื่อตรวจสอบข้อมูลปัจจุบัน การแปลจัดทำโดย Google Translate และอาจไม่ถูกต้องทั้งหมด",
        "uk-UK": "Відмова від відповідальності: будь ласка, зв’яжіться безпосередньо з надавачами послуг, щоб перевірити актуальну інформацію. Переклади надає Google Translate, і вони можуть бути не повністю точними.",
    },
    ircMapDisclaimer: {
        "en-US": "This map contains both ORR and non-ORR programs. The ORR programs shown on this map do not represent an exhaustive list."
    },
    ircFundingDisclaimer: {
        "en-US": "The IRC received competitive funding through the U.S. Department of Health and Human Services, Administration for Children and Families, Grant #90RB0053. The project is 100% financed by federal funds. The contents of this document are solely the responsibility of the authors and do not necessarily represent the official views of the U.S. Department of Health and Human Services, Administration for Children and Families.",
        am: "IRC በዩኤስ የጤናና የሰብአዊ አገልግሎት መምሪያ፣ የልጆችና ቤተሰቦች አስተዳደር በውድድር የተገኘ የገንዘብ ድጋፍ አግኝቷል፣ የስጦታ ቁጥር #90RB0053። ፕሮጀክቱ 100% በፌዴራል ገንዘብ የተሸፈነ ነው። የዚህ ሰነድ ይዘቶች የደራሲዎቹ ብቻ ኃላፊነት ሲሆን የዩኤስ የጤናና የሰብአዊ አገልግሎት መምሪያ፣ የልጆችና ቤተሰቦች አስተዳደር ኦፊሴላዊ አመለካከትን አያመለክቱም።",
        "ar-SA": "حصلت IRC على تمويل تنافسي من خلال وزارة الصحة والخدمات الإنسانية الأمريكية، إدارة شؤون الأطفال والأسرة، المنحة رقم #90RB0053. المشروع ممول بنسبة 100% من الأموال الفيدرالية. محتويات هذا المستند هي مسؤولية المؤلفين وحدهم ولا تمثل بالضرورة الآراء الرسمية لوزارة الصحة والخدمات الإنسانية الأمريكية، إدارة شؤون الأطفال والأسرة.",
        "fr-FR": "L'IRC a reçu un financement compétitif du Département américain de la Santé et des Services sociaux, Administration pour les enfants et les familles, subvention n° 90RB0053. Le projet est financé à 100 % par des fonds fédéraux. Le contenu de ce document relève uniquement de la responsabilité des auteurs et ne représente pas nécessairement les positions officielles du Département américain de la Santé et des Services sociaux, Administration pour les enfants et les familles.",
        "es-ES": "IRC recibió financiamiento competitivo a través del Departamento de Salud y Servicios Humanos de EE. UU., Administración para Niños y Familias, subvención n.º 90RB0053. El proyecto está financiado al 100 % con fondos federales. El contenido de este documento es responsabilidad exclusiva de los autores y no representa necesariamente las opiniones oficiales del Departamento de Salud y Servicios Humanos de EE. UU., Administración para Niños y Familias.",
        "so-SO": "RC waxay maalgelin tartan ah ka heshay Waaxda Caafimaadka iyo Adeegyada Aadanaha ee Maraykanka, Maamulka Carruurta iyo Qoysaska, Deeqda lambarkeedu yahay 90RB0053. Mashruucan waxaa 100% lagu maalgeliyey lacagaha federaalka. Waxyaabaha ku qoran dokumentigan waxaa mas’uul ka ah qorayaasha oo keliya, mana aha kuwo daruuri ahaan ka tarjumaya aragtida rasmiga ah ee Waaxda Caafimaadka iyo Adeegyada Aadanaha ee Maraykanka, Maamulka Carruurta iyo Qoysaska.",
        "ur-UR": "IRC کو امریکی محکمہ صحت اور انسانی خدمات، بچوں اور خاندانوں کی انتظامیہ کے ذریعے مسابقتی فنڈنگ ملی، گرانٹ #90RB0053۔ یہ منصوبہ 100% وفاقی فنڈز سے مالی اعانت یافتہ ہے۔ اس دستاویز کے مندرجات صرف مصنفین کی ذمہ داری ہیں اور لازمی طور پر امریکی محکمہ صحت اور انسانی خدمات، بچوں اور خاندانوں کی انتظامیہ کے سرکاری خیالات کی نمائندگی نہیں کرتے۔",
        "ht": "IRC te resevwa finansman konpetitif atravè Depatman Sante ak Sèvis Imen Etazini, Administrasyon pou Timoun ak Fanmi, Sibvansyon #90RB0053. Pwojè a finanse 100% ak lajan federal. Kontni dokiman sa a se responsablite otè yo sèlman epi li pa nesesèman reprezante opinyon ofisyèl Depatman Sante ak Sèvis Imen Etazini, Administrasyon pou Timoun ak Fanmi.",
        "fr-HT": "IRC te resevwa finansman konpetitif atravè Depatman Sante ak Sèvis Imen Etazini, Administrasyon pou Timoun ak Fanmi, Sibvansyon #90RB0053. Pwojè a finanse 100% ak lajan federal. Kontni dokiman sa a se responsablite otè yo sèlman epi li pa nesesèman reprezante opinyon ofisyèl Depatman Sante ak Sèvis Imen Etazini, Administrasyon pou Timoun ak Fanmi.",
        "bn": "IRC মার্কিন স্বাস্থ্য ও মানবসেবা বিভাগ, শিশু ও পরিবার প্রশাসনের মাধ্যমে প্রতিযোগিতামূলক তহবিল পেয়েছে, অনুদান #90RB0053। প্রকল্পটি ১০০% ফেডারেল তহবিল দ্বারা অর্থায়িত। এই নথির বিষয়বস্তু সম্পূর্ণরূপে লেখকদের দায়িত্ব এবং মার্কিন স্বাস্থ্য ও মানবসেবা বিভাগ, শিশু ও পরিবার প্রশাসনের সরকারি মতামতকে অগতশ্যই প্রতিনিধিত্ব করে না।",
        "my": "IRC သည် အမေရိကန် ကျန်းမာရေးနှင့် လူ့ဝန်ဆောင်မှုဌာန၊ ကလေးများနှင့် မိသားစုများ အုပ်ချုပ်ရေးမှ ယှဉ်ပြိုင်ရရှိသော ရန်ပုံငွေကို ရရှိခဲ့သည်၊ ထောက်ပံ့ငွေ #90RB0053။ စီမံကိန်းကို ဖက်ဒရယ်ရန်ပုံငွေဖြင့် 100% ငွေကြေးထောက်ပံ့ထားသည်။ ဤစာရွက်စာတမ်း၏ အကြောင်းအရာများသည် စာရေးသူများ၏ တာဝန်သာဖြစ်ပြီး အမေရိကန် ကျန်းမာရေးနှင့် လူ့ဝန်ဆောင်မှုဌာန၊ ကလေးများနှင့် မိသားစုများ အုပ်ချုပ်ရေး၏ တရားဝင်အမြင်များကို မဖြစ်မနေ ကိုယ်စားမပြုပါ။",
        "cs": "IRC získala konkurenční financování prostřednictvím amerického ministerstva zdravotnictví a sociálních služeb, Správy pro děti a rodiny, grant č. 90RB0053. Projekt je ze 100 % financován federálními prostředky. Obsah tohoto dokumentu je výhradně odpovědností autorů a nemusí nutně představovat oficiální názory amerického ministerstva zdravotnictví a sociálních služeb, Správy pro děti a rodiny.",
        "fa-AF": "کمیته بین المللی نجات (آی آر سی) این بودجه رقابتی را از طریق وزارت صحت و خدمات بشری و اداره امور کودکان و خانواده ها تحت بودجه حمایتی #۹۰RB۰۰۵۳ دریافت کرده است. این پروژه به طور کامل از بودجه فدرال ایالات متحده تأمین مالی شده است. محتوای این سند صرفا مسؤلیت نویسندگان آن است و  لزوما بیانگر دیدگاه های  رسمی وزارت صحت و خدمات بشری ایالات متحده آمریکا یا اداره امور کودکان و خانوده ها نمی باشد",
        "fa-FA": "IRC از طریق وزارت بهداشت و خدمات انسانی ایالات متحده، اداره کودکان و خانواده‌ها، کمک‌هزینه رقابتی شماره #90RB0053 دریافت کرده است. این پروژه ۱۰۰٪ با بودجه فدرال تأمین مالی می‌شود. محتوای این سند صرفاً مسئولیت نویسندگان است و لزوماً دیدگاه‌های رسمی وزارت بهداشت و خدمات انسانی ایالات متحده، اداره کودکان و خانواده‌ها را نمایندگی نمی‌کند.",
        "de-DE": "Die IRC hat wettbewerbsfähige Finanzierung über das US-Gesundheitsministerium, Verwaltung für Kinder und Familien, Zuschuss Nr. 90RB0053 erhalten. Das Projekt wird zu 100 % mit Bundesmitteln finanziert. Der Inhalt dieses Dokuments liegt allein in der Verantwortung der Autoren und gibt nicht notwendigerweise die offiziellen Ansichten des US-Gesundheitsministeriums, Verwaltung für Kinder und Familien, wieder.",
        "el": "Το IRC έλαβε ανταγωνιστική χρηματοδότηση μέσω του Υπουργείου Υγείας και Ανθρωπίνων Υπηρεσιών των ΗΠΑ, Διοίκηση για Παιδιά και Οικογένειες, Επιχορήγηση #90RB0053. Το έργο χρηματοδοτείται 100% από ομοσπονδιακά κονδύλια. Το περιεχόμενο αυτού του εγγράφου αποτελεί αποκλειστική ευθύνη των συγγραφέων και δεν αντιπροσωπεύει απαραίτητα τις επίσημες απόψεις του Υπουργείου Υγείας και Ανθρωπίνων Υπηρεσιών των ΗΠΑ, Διοίκηση για Παιδιά και Οικογένειες.",
        "ha-HA": "IRC ta sami tallafin gasa ta hanyar Ma'aikatar Lafiya da Ayyukan 'Yan Adam ta Amurka, Hukumar Yara da Iyalai, Tallafi #90RB0053. An tallafa wa aikin da kudi na tarayya 100%. Abubuwan da ke cikin wannan takarda alhakin marubuta ne kawai kuma ba lallai ba ne su wakilci ra'ayoyin hukuma na Ma'aikatar Lafiya da Ayyukan 'Yan Adam ta Amurka, Hukumar Yara da Iyalai.",
        "hu-HU": "Az IRC versenyeztetett finanszírozást kapott az Egyesült Államok Egészségügyi és Emberi Szolgáltatások Minisztériumán, a Gyermekek és Családok Hivatalán keresztül, #90RB0053 számú támogatással. A projektet 100%-ban szövetségi források finanszírozzák. A dokumentum tartalmáért kizárólag a szerzők felelősek, és nem feltétlenül tükrözi az Egyesült Államok Egészségügyi és Emberi Szolgáltatások Minisztériuma, Gyermekek és Családok Hivatala hivatalos álláspontját.",
        "it-IT": "L'IRC ha ricevuto finanziamenti competitivi attraverso il Dipartimento della Salute e dei Servizi Umani degli Stati Uniti, Amministrazione per i Bambini e le Famiglie, Sovvenzione #90RB0053. Il progetto è finanziato al 100% con fondi federali. I contenuti di questo documento sono di esclusiva responsabilità degli autori e non rappresentano necessariamente le opinioni ufficiali del Dipartimento della Salute e dei Servizi Umani degli Stati Uniti, Amministrazione per i Bambini e le Famiglie.",
        "KAU": "IRC ta sami tallafin gasa ta hanyar Ma'aikatar Lafiya da Ayyukan 'Yan Adam ta Amurka, Hukumar Yara da Iyalai, Tallafi #90RB0053. An tallafa wa aikin da kudi na tarayya 100%. Abubuwan da ke cikin wannan takarda alhakin marubuta ne kawai kuma ba lallai ba ne su wakilci ra'ayoyin hukuma na Ma'aikatar Lafiya da Ayyukan 'Yan Adam ta Amurka, Hukumar Yara da Iyalai.",
        "ki-KI": "IRC yakiriye inkunga y'amarushanwa binyuze muri Minisiteri y'Ubuzima n'Amavugurura y'Abantu ya Leta Zunze Ubumwe z'Amerika, Ubuyobozi bw'Abana n'Imiryango, Inkunga #90RB0053. Umushinga wose wishyuwe 100% n'amafaranga ya leta. Ibirimo muri iyi nyandiko ni inshingano z'abanditsi gusa kandi ntibisobanura ko bishyira imbere ibitekerezo byemewe na Minisiteri y'Ubuzima n'Amavugurura y'Abantu ya Leta Zunze Ubumwe z'Amerika, Ubuyobozi bw'Abana n'Imiryango.",
        "ln-LN": "IRC ezwaki mosolo ya concurrence na nzela ya Ministère ya Santé mpe Services Humains ya États-Unis, Administration ya Bana mpe Libota, Subvention #90RB0053. Projet ezali kobongwana 100% na mosolo ya fédéral. Makambo ya document oyo ezali kaka responsabilité ya bakomi mpe ezali te kozala opinion officielle ya Ministère ya Santé mpe Services Humains ya États-Unis, Administration ya Bana mpe Libota.",
        "ps-PS": "IRC د متحده ایالاتو د روغتیا او بشري خدماتو وزارت، د ماشومانو او کورنیو ادارې له لارې سیالي تمویل ترلاسه کړی، مرسته #90RB0053. پروژه ۱۰۰٪ د فدرالي بودیجې له لارې تمویل شوې ده. د دې سند منځپانګه یوازې د لیکوالانو مسؤلیت دی او اړینه نه ده چې د متحده ایالاتو د روغتیا او بشري خدماتو وزارت، د ماشومانو او کورنیو ادارې رسمي نظرونه وښيي.",
        "ru-RU": "IRC получила конкурентное финансирование через Министерство здравоохранения и социальных служб США, Администрацию по делам детей и семей, грант № 90RB0053. Проект на 100% финансируется федеральными средствами. Содержание этого документа является исключительной ответственностью авторов и не обязательно отражает официальную позицию Министерства здравоохранения и социальных служб США, Администрации по делам детей и семей.",
        "sw-SW": "IRC ilipokea ufadhili wa ushindani kupitia Idara ya Afya na Huduma za Binadamu ya Marekani, Utawala wa Watoto na Familia, Ruzuku #90RB0053. Mradi umefadhiliwa 100% na fedha za shirikisho. Maudhui ya hati hii ni jukumu la waandishi pekee na si lazima yawakilishe maoni rasmi ya Idara ya Afya na Huduma za Binadamu ya Marekani, Utawala wa Watoto na Familia.",
        "th": "IRC ได้รับเงินทุนจากการแข่งขันผ่านกระทรวงสาธารณสุขและบริการมนุษย์ของสหรัฐอเมริกา สำนักงานบริหารเด็กและครอบครัว ทุน #90RB0053 โครงการนี้ได้รับการสนับสนุน 100% จากเงินทุนของรัฐบาลกลาง เนื้อหาในเอกสารนี้เป็นความรับผิดชอบของผู้เขียนเท่านั้น และไม่จำเป็นต้องเป็นตัวแทนของมุมมองอย่างเป็นทางการของกระทรวงสาธารณสุขและบริการมนุษย์ของสหรัฐอเมริกา สำนักงานบริหารเด็กและครอบครัว",
        "uk-UK": "IRC отримала конкурсне фінансування через Міністерство охорони здоров'я та соціальних служб США, Адміністрацію у справах дітей і сімей, грант № 90RB0053. Проєкт на 100% фінансується федеральними коштами. Зміст цього документа є виключною відповідальністю авторів і не обов'язково відображає офіційну позицію Міністерства охорони здоров'я та соціальних служб США, Адміністрації у справах дітей і сімей.",
    },
}
